import React, { useRef, useState, useEffect } from "react";
import { default as BookCalendar } from "../../../routes/modules/Calendar";
import { useMountEffect } from 'primereact/hooks';
import { useFormik } from 'formik';
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { send, notify } from "../../../services/NotificationService";
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { AutoComplete } from 'primereact/autocomplete';
import { Calendar } from 'primereact/calendar';
import { Panel } from 'primereact/panel';
import { Dialog } from 'primereact/dialog';
import { Tooltip } from 'primereact/tooltip';
import { IsNullOrEmpty } from "../../../services/CustomService";
import { INVALID_PHONE_MESSAGE, isPhoneTooLong } from "../../../services/phone";
import { getAccount, getUserSettings } from "../../../data/accounts";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { MultiSelect } from 'primereact/multiselect';
import { getEvents } from "../../../data/loca/events";
import moment from "moment";

import {
    Form,
    redirect,
    useActionData,
    useLoaderData,
    useNavigate,
    useSubmit
} from "react-router-dom";
import { getTools,getTool,  getToolOptions, isAvalaibleTool } from "../../../data/loca/tools";
import { getClients, getClient } from "../../../data/loca/clients";
import { getServices } from "../../../data/loca/services";
import { createRental, extractBricolibContract, getRental, updateRentalData, permanentLinkNeeded, updateRental, getPrice, getDeliveryEstimateOrigins, estimateDeliveryFees, autocompleteDeliveryAddress } from "../../../data/loca/rentals";
import { deleteRentalDraft, getRentalDraft, saveRentalDraft } from "../../../data/loca/rentalDrafts";
import { DeliveryVehicleNotice, useDeliveryVehicleCheck } from "./DeliveryVehicleNotice";

const ADVANCE_PAYMENT_MODES = [
    { value: "SumUp", label: "SumUp", icon: "pi pi-credit-card", helper: "Carte bancaire simple" },
    { value: "Stripe", label: "Stripe", icon: "pi pi-wallet", helper: "Carte bancaire" },
    { value: "Manual", label: "Hors plateforme", icon: "pi pi-money-bill", helper: "Virement, espèces..." }
];

const DEFAULT_ADVANCE_PAYMENT_FEE_CONFIGURATIONS = [
    { name: "SumUp", percentage: 1.75, fixedFeeCents: 0 },
    { name: "Stripe", percentage: 1.5, fixedFeeCents: 80 },
    { name: "Hors plateforme", percentage: 0, fixedFeeCents: 0 }
];

export async function loader({ params, request }) {
    const acc = await getAccount();
    const settings = await getUserSettings();

    if (acc.needComplementaryInfo) {
        return redirect(`/informations-complementaires`);
    }
    const services = await getServices();
    
    var othersEvent = await getEvents();

    // on recupere la paramettre clientId en get
    var urlParams = new URL(request.url).searchParams;
    var clientId = urlParams.get('clientId');
    var paramsMaterialId = urlParams.get('toolId');
    var draftId = urlParams.get('draftId');

    var preselectMaterial = null;
    if (paramsMaterialId) {
        preselectMaterial = await getTool(paramsMaterialId);
    }
    var preselectClient = null;
    if (clientId) {
        preselectClient = await getClient(clientId);
    }
   
    if (params.rentalId) {
        const rental = await getRental(params.rentalId);

        return { services, rental, acc, settings, preselectClient, preselectMaterial, othersEvent, localDraft: null };
    }
    const rental = null;
    let localDraft = null;

    if (draftId) {
        try {
            const draft = await getRentalDraft(draftId);
            if (draft) {
                let payload = {};
                try {
                    payload = draft.json ? JSON.parse(draft.json) : {};
                } catch (error) {
                    payload = {};
                }
                localDraft = {
                    id: draft.publicId,
                    createdAt: draft.createdAtUtc,
                    updatedAt: draft.updatedAtUtc,
                    displayName: draft.displayName,
                    values: payload.values || {},
                    selectedOptionIds: payload.selectedOptionIds || [],
                    availableDeposit: payload.availableDeposit,
                    availableAdvancePayment: payload.availableAdvancePayment,
                    advancePaymentCollectionMode: payload.advancePaymentCollectionMode,
                    signatureRequired: payload.signatureRequired
                };
            }
        } catch (error) {
            localDraft = null;
        }
    }
    return { services, rental, acc, settings, preselectClient, preselectMaterial, othersEvent, localDraft };
}

export async function action({ request, params }) {

    const formData = await request.formData();
    const data = Object.fromEntries(formData);

    // En cas de refus (créneau indisponible...), on reste sur le formulaire : le composant affiche la notification.
    let id;
    try {
        if (params.rentalId)
            id = await updateRentalData(data, params.rentalId);
        else
            id = await createRental(data);
    } catch (error) {
        if (error instanceof Response)
            throw error;
        return { error: error?.message || "Une erreur est survenue lors de l'enregistrement de la location." };
    }

    if (typeof id !== "string" || IsNullOrEmpty(id)) {
        return { error: id?.message || id?.Message || id?.error || "Une erreur est survenue lors de l'enregistrement de la location." };
    }

    // Le brouillon n'est supprimé qu'une fois la location enregistrée.
    if (data.localDraftId) {
        try {
            await deleteRentalDraft(data.localDraftId);
            window.dispatchEvent(new Event("rental-drafts-updated"));
        } catch (error) {
            console.error("Erreur lors de la suppression du brouillon local :", error);
        }
    }

    return redirect(`/` + id);
}

export default function AddRental() {
    const navigate = useNavigate();
    const submit = useSubmit();
    const msgs = useRef(null);
    const { services, rental, acc, settings, preselectClient, preselectMaterial, othersEvent, localDraft } = useLoaderData();
    const actionData = useActionData();

    const [localDraftId, setLocalDraftId] = useState(localDraft?.id ?? null);
    const [localDraftMeta, setLocalDraftMeta] = useState({
        createdAt: localDraft?.createdAt ?? null,
        updatedAt: localDraft?.updatedAt ?? null
    });
    const [localDraftOptionIds, setLocalDraftOptionIds] = useState(localDraft?.selectedOptionIds ?? []);
    const [isSaving, setIsSaving] = useState(false);
    const draftSaveInFlight = useRef(false);
    const localDraftIdRef = useRef(localDraft?.id ?? null);

    // Enregistrement refusé par l'API (créneau indisponible...) : notification, on reste sur le formulaire.
    useEffect(() => {
        if (!actionData?.error) {
            return;
        }
        send("warning", actionData.error);
        notify();
        setIsSaving(false);
    }, [actionData]);

    let appointments = [];

    const toLocalDate = (value) => {
        if (!value) return value;
        if (value instanceof Date) return new Date(value.getTime());
        const parsed = moment.parseZone(value);
        if (!parsed.isValid()) return new Date(value);
        return new Date(
            parsed.year(),
            parsed.month(),
            parsed.date(),
            parsed.hour(),
            parsed.minute(),
            parsed.second(),
            parsed.millisecond(),
        );
    };

    const formatDraftDate = (value) => {
        if (!value) {
            return "-";
        }

        const parsedDate = toLocalDate(value);
        if (!parsedDate || Number.isNaN(parsedDate.getTime())) {
            return "-";
        }

        return parsedDate.toLocaleString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    };

    othersEvent.forEach(event => {
        let start = toLocalDate(event.startDate);
        let end = toLocalDate(event.endDate);
        appointments.push({
            id: event.id,
            title: event.title,
            notes: event.notes ?? event.Notes,
            type: "others",
            color: "#4C566A",
            startDate: start,
            endDate: end
        });
    });
    const [actualPrice, setActualPrice] = useState();
    // Outil d'estimation des frais de livraison (trajet simple calcule par l'API + tarif des parametres).
    const [deliveryEstimate, setDeliveryEstimate] = useState(null);
    // Proposition retenue parmi les deux (au temps / a la distance) ; la plus avantageuse est preselectionnee par l'API.
    const [deliverySelectedMode, setDeliverySelectedMode] = useState(null);
    const [deliveryEstimateLoading, setDeliveryEstimateLoading] = useState(false);
    const [deliveryEstimateError, setDeliveryEstimateError] = useState(null);
    const [deliveryOrigins, setDeliveryOrigins] = useState([]);
    const [deliveryOriginKey, setDeliveryOriginKey] = useState("profile");
    const [deliveryAddressSuggestions, setDeliveryAddressSuggestions] = useState([]);
    const [deliveryAutocompleteError, setDeliveryAutocompleteError] = useState(null);
    const deliveryOriginTouchedRef = useRef(false);
    const [tooloptions, setTooloptions] = useState();
    const [selectedOptions, setSelectedOptions] = useState();
    const [optionQuantities, setOptionQuantities] = useState({});
    const [optionQuantityErrors, setOptionQuantityErrors] = useState({});
    const [showOptionQuantityModal, setShowOptionQuantityModal] = useState(false);
    const [depositAmount, setDepositAmount] = useState();
    const [availableDeposit, setAvailableDeposit] = useState("1");
    const [availableAdvancePayment, setAvailableAdvancePayment] = useState((!rental && (settings?.defaultAdvancePaymentPercent ?? 0) > 0) ? "1" : "0");
    const [advancePaymentCollectionMode, setAdvancePaymentCollectionMode] = useState(rental?.advancePaymentCollectionMode || localDraft?.advancePaymentCollectionMode || localDraft?.values?.advancePaymentCollectionMode || "SumUp");
    const [signatureRequired, setSignatureRequired] = useState((!rental && settings?.requireElectronicSignatureByDefault) ? "1" : "0");
    //
    const [permanentLinkDepositBloc, setPermanentLinkDepositBloc] = useState(false);
    const [selectedMaterials, setSelectedMaterials] = useState(null);
    const [materialQuantities, setMaterialQuantities] = useState({});
    const [materialQuantityErrors, setMaterialQuantityErrors] = useState({});
    const [showQuantityModal, setShowQuantityModal] = useState(false);
    const [isExtractingBricolibPdf, setIsExtractingBricolibPdf] = useState(false);
    const [showBricolibModal, setShowBricolibModal] = useState(false);
    const [advancePercentHint, setAdvancePercentHint] = useState(null);
    const lastSuggestedAdvanceAmount = useRef(null);
    const hydratingDraftRef = useRef(false);

    const [openTools, setOpenTools] = React.useState(false);
    const [optionscompleteTools, setOptionscompleteTools] = React.useState([]);
    const loadingTools = openTools && optionscompleteTools.length === 0;

    const calculateDepositAmount = (materials, tools) => {
        if (!Array.isArray(materials) || materials.length === 0 || !Array.isArray(tools) || tools.length === 0) {
            return undefined;
        }

        const totalDepositCents = materials.reduce((total, materialId) => {
            const tool = tools.find((item) => item.value === materialId);
            return total + (tool?.deposit || 0);
        }, 0);

        return totalDepositCents / 100;
    };

    const getRequiredAdvancePercent = (materials) => {
        const defaultPercent = Number(settings?.defaultAdvancePaymentPercent || 0);
        if (!Array.isArray(materials) || materials.length === 0) {
            return defaultPercent;
        }

        return materials.reduce((maxPercent, materialId) => {
            const tool = optionscompleteTools.find((item) => item.value === materialId);
            const percent = Number(tool?.advancedPaymentPercentRequired || 0);
            return Math.max(maxPercent, percent);
        }, defaultPercent);
    };

    const formatMoneyValue = (amount) => {
        const fixed = (Math.round(amount * 100) / 100).toFixed(2);
        return fixed.replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
    };

    const parseMoneyValue = (value) => {
        if (value === null || value === undefined || value === '') {
            return 0;
        }

        const parsed = Number(String(value).replace(',', '.'));
        return Number.isNaN(parsed) ? 0 : parsed;
    };

    const formatAmount = (amountCents) => `${((amountCents ?? 0) / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}€`;

    const getAdvancePaymentModeFromFeeName = (name) => {
        const normalized = normalizeForToolSearch(name);
        if (normalized.includes("stripe")) {
            return "Stripe";
        }
        if (normalized.includes("sumup") || normalized.includes("sum up")) {
            return "SumUp";
        }
        return "Manual";
    };

    const getAdvancePaymentModeLabel = (mode) => {
        return ADVANCE_PAYMENT_MODES.find((item) => item.value === mode)?.label ?? mode;
    };

    const getAdvancePaymentFeeComparisons = () => {
        const amountCents = Math.round(parseMoneyValue(formik.values.advancePaymentAmountCentsNeeded) * 100);
        if (amountCents <= 0) {
            return [];
        }

        const configuredFees = Array.isArray(settings?.paymentFeeConfigurations) && settings.paymentFeeConfigurations.length > 0
            ? settings.paymentFeeConfigurations
            : DEFAULT_ADVANCE_PAYMENT_FEE_CONFIGURATIONS;

        return configuredFees
            .filter((configuration) => configuration?.name?.trim())
            .map((configuration) => {
                const mode = getAdvancePaymentModeFromFeeName(configuration.name);
                const percentage = Number(configuration.percentage ?? 0);
                const fixedFeeCents = Number(configuration.fixedFeeCents ?? 0);
                const feesCents = Math.round((amountCents * percentage) / 100) + fixedFeeCents;
                return {
                    ...configuration,
                    mode,
                    feesCents,
                    netCents: amountCents - feesCents
                };
            })
            .sort((first, second) => first.feesCents - second.feesCents);
    };

    const getAdvancePaymentModeOptions = () => {
        const configuredFees = Array.isArray(settings?.paymentFeeConfigurations) && settings.paymentFeeConfigurations.length > 0
            ? settings.paymentFeeConfigurations
            : DEFAULT_ADVANCE_PAYMENT_FEE_CONFIGURATIONS;
        const configuredModes = new Set();

        configuredFees.forEach((configuration) => {
            if (!configuration?.name?.trim()) {
                return;
            }

            configuredModes.add(getAdvancePaymentModeFromFeeName(configuration.name));
        });

        if (advancePaymentCollectionMode) {
            configuredModes.add(advancePaymentCollectionMode);
        }

        const modes = ADVANCE_PAYMENT_MODES.filter((mode) => configuredModes.size === 0 || configuredModes.has(mode.value));
        return modes.length > 0 ? modes : ADVANCE_PAYMENT_MODES;
    };

    const normalizeForToolSearch = (value) => {
        if (!value) {
            return "";
        }

        return value
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim();
    };

    const formatToolsForSelection = (tools) => {
        if (!Array.isArray(tools)) {
            return [];
        }

        return tools.map((tool) => {
            const brand = tool.brand ? tool.brand : "";
            const model = tool.model ? tool.model : "";
            return {
                ...tool,
                name: `${tool.name} ${brand} ${model}`.trim(),
                value: tool.publicId
            };
        });
    };

    const ensureToolsLoaded = async () => {
        if (optionscompleteTools.length > 0) {
            return optionscompleteTools;
        }

        const tools = await getTools();
        const formattedTools = formatToolsForSelection(tools);
        setOptionscompleteTools(formattedTools);
        return formattedTools;
    };

    const findToolIdFromPdf = (toolLabel, tools) => {
        const normalizedToolLabel = normalizeForToolSearch(toolLabel);
        if (!normalizedToolLabel || !Array.isArray(tools) || tools.length === 0) {
            return null;
        }

        const exactMatch = tools.find((tool) => normalizeForToolSearch(tool.name) === normalizedToolLabel);
        if (exactMatch) {
            return exactMatch.value;
        }

        const includesMatch = tools.find((tool) => {
            const normalizedName = normalizeForToolSearch(tool.name);
            return normalizedName.includes(normalizedToolLabel) || normalizedToolLabel.includes(normalizedName);
        });

        return includesMatch?.value || null;
    };

    const parseFrenchDateToLocalDate = (value) => {
        if (!value || typeof value !== 'string') {
            return null;
        }

        const match = value.match(/(\d{2})\/(\d{2})\/(\d{4})/);
        if (!match) {
            return null;
        }

        const day = Number(match[1]);
        const month = Number(match[2]);
        const year = Number(match[3]);

        if (!day || !month || !year) {
            return null;
        }

        const parsed = new Date(year, month - 1, day);
        if (Number.isNaN(parsed.getTime())) {
            return null;
        }

        return parsed;
    };

    const isBricolibServiceByValue = (serviceValue) => {
        const service = formattedServices.find((item) => item.value === serviceValue);
        return (service?.name || "").toLowerCase().includes("bricolib");
    };

    const buildMaterialQuantities = (materials) => {
        if (!Array.isArray(materials)) {
            return {};
        }

        return materials.reduce((acc, materialId) => {
            if (!materialId) {
                return acc;
            }
            acc[materialId] = (acc[materialId] || 0) + 1;
            return acc;
        }, {});
    };

    const expandMaterialsFromQuantities = (quantities) => {
        if (!quantities || typeof quantities !== 'object') {
            return [];
        }

        return Object.entries(quantities).flatMap(([materialId, quantity]) => {
            const safeQty = Math.max(1, Number(quantity) || 1);
            return Array.from({ length: safeQty }, () => materialId);
        });
    };

    const isValidQuantity = (quantity) => {
        const parsedQuantity = Number(quantity);
        return Number.isInteger(parsedQuantity) && parsedQuantity > 0 && parsedQuantity <= 999;
    };

    const getTotalSelectedMaterials = (materials, quantities) => {
        if (!Array.isArray(materials) || materials.length === 0) {
            return 0;
        }

        return materials.reduce((total, materialId) => {
            const qty = Number(quantities?.[materialId]);
            return total + (Number.isInteger(qty) && qty > 0 ? qty : 1);
        }, 0);
    };

    const getExpandedMaterialsFromSelection = (materials, quantities) => {
        if (!Array.isArray(materials)) {
            return [];
        }

        return materials.flatMap((materialId) => {
            const qty = Number(quantities?.[materialId]);
            return Number.isInteger(qty) && qty > 0
                ? Array.from({ length: qty }, () => materialId)
                : [];
        });
    };

    const buildOptionQuantities = (optionIds) => {
        if (!Array.isArray(optionIds)) {
            return {};
        }

        return optionIds.reduce((acc, optionId) => {
            if (!optionId) {
                return acc;
            }
            acc[optionId] = (acc[optionId] || 0) + 1;
            return acc;
        }, {});
    };

    const getOptionId = (option) => option?.Id ?? option?.id;

    const getExpandedOptionIdsFromSelection = (options, quantities) => {
        if (!Array.isArray(options)) {
            return [];
        }

        return options.flatMap((option) => {
            const optionId = getOptionId(option);
            if (!optionId) {
                return [];
            }
            const qty = Number(quantities?.[optionId]);
            return Number.isInteger(qty) && qty > 0
                ? Array.from({ length: qty }, () => optionId)
                : [];
        });
    };

    const getTotalSelectedOptions = (options, quantities) => {
        if (!Array.isArray(options) || options.length === 0) {
            return 0;
        }

        return options.reduce((total, option) => {
            const optionId = getOptionId(option);
            const qty = Number(quantities?.[optionId]);
            return total + (Number.isInteger(qty) && qty > 0 ? qty : 1);
        }, 0);
    };

    const getSelectedOptionsTotalCents = (options, quantities) => {
        if (!Array.isArray(options) || options.length === 0) {
            return 0;
        }

        return options.reduce((total, option) => {
            const optionId = getOptionId(option);
            if (!optionId) {
                return total;
            }

            const qty = Number(quantities?.[optionId]);
            const quantity = Number.isInteger(qty) && qty > 0 ? qty : 1;
            const applicableTier = getApplicableMerchandiseTier(option, quantity);
            const unitPriceCents = applicableTier
                ? Math.round(Number(applicableTier.unitPrice ?? applicableTier.UnitPrice) * 100)
                : (option.PriceCents ?? option.priceCents ?? 0);
            return total + (unitPriceCents * quantity);
        }, 0);
    };

    const getMerchandiseTierMinimum = (tier) => Number(tier.minimumQuantity ?? tier.MinimumQuantity);

    const getApplicableMerchandiseTier = (option, quantity) => {
        const tiers = option?.MerchandisePriceTiers ?? option?.merchandisePriceTiers ?? [];
        if (tiers.length === 0) {
            return undefined;
        }

        const sortedByMinimum = [...tiers].sort((a, b) => getMerchandiseTierMinimum(a) - getMerchandiseTierMinimum(b));
        const matchingTier = sortedByMinimum
            .filter((tier) => getMerchandiseTierMinimum(tier) <= quantity)
            .pop();
        // Sous le premier palier : on applique le plus petit palier comme prix plancher.
        return matchingTier ?? sortedByMinimum[0];
    };

    const mergeAvailableAndSelectedOptions = (availableOptions, selectedValues) => {
        const mergedOptions = [];
        const usedOptionIds = new Set();
        const normalizeOptionId = (option) => String(getOptionId(option) ?? "");

        (availableOptions || []).forEach((option) => {
            const optionId = normalizeOptionId(option);
            if (!optionId || usedOptionIds.has(optionId)) {
                return;
            }
            mergedOptions.push(option);
            usedOptionIds.add(optionId);
        });

        (selectedValues || []).forEach((option) => {
            const optionId = normalizeOptionId(option);
            if (!optionId || usedOptionIds.has(optionId)) {
                return;
            }
            mergedOptions.push({
                ...option,
                unavailable: option.IsActivated === false || option.isActivated === false
            });
            usedOptionIds.add(optionId);
        });

        return mergedOptions;
    };


    let formattedServices = [];
    for (let i = 0; i < services.length; i++) {
        formattedServices[i] = { ...services[i], name: services[i].name, value: services[i].id };
    }

    const formattedDeliveries = [];
    formattedDeliveries[0] = { name: "Sans livraison", value: "NoDelivery" }; 
    formattedDeliveries[1] = { name: "Livraison avec reprise", value: "DeliveryWithPickup" }; 
    formattedDeliveries[2] = { name: "Livraison avec reprise et installation", value: "DeliveryWithPickupAndSetup" }; 
    formattedDeliveries[3] = { name: "Livraison uniquement", value: "DeliveryOnly" }; 
    formattedDeliveries[4] = { name: "Reprise uniquement", value: "PickupOnly" }; 

    const hasDeliveryOrPickup = (delivery) => delivery && delivery !== "NoDelivery";

    const getDeliveryFeesAmount = (delivery, deliveryFees) => {
        if (!hasDeliveryOrPickup(delivery)) {
            return 0;
        }

        return Math.max(0, parseMoneyValue(deliveryFees));
    };

    const getCurrentDeliveryFeesAmount = () => getDeliveryFeesAmount(formik.values.deliveryId, formik.values.deliveryFees);

    // --- Estimation des frais de livraison -------------------------------------------------
    const DELIVERY_LEG_COUNTS = { DeliveryWithPickup: 2, DeliveryWithPickupAndSetup: 2, DeliveryOnly: 1, PickupOnly: 1 };
    const getDeliveryLegCount = (delivery) => DELIVERY_LEG_COUNTS[delivery] || 0;

    // Proposition (au temps ou a la distance) d'une estimation ; repli sur la proposition preselectionnee.
    const getDeliveryProposal = (estimate, mode) => {
        if (!estimate) {
            return null;
        }
        const proposals = Array.isArray(estimate.proposals) ? estimate.proposals : [];
        return proposals.find((proposal) => proposal.mode === mode)
            || proposals.find((proposal) => proposal.recommended)
            || proposals[0]
            || estimate;
    };

    // Meme regle que l'API : prix d'un passage x nombre de passages (+ supplement installation).
    const computeDeliveryEstimateTotalCents = (estimate, delivery, mode) => {
        const proposal = getDeliveryProposal(estimate, mode);
        if (!proposal) {
            return 0;
        }
        const legCount = getDeliveryLegCount(delivery);
        if (legCount === 0) {
            return 0;
        }
        const setupSupplementCents = delivery === "DeliveryWithPickupAndSetup" ? (proposal.setupSupplementCents || 0) : 0;
        // Peages et indexation carburant comptes a chaque passage, comme dans l'API.
        return ((proposal.legPriceCents || 0) + (proposal.tollCentsPerLeg || 0) + (proposal.fuelSurchargeCentsPerLeg || 0)) * legCount + setupSupplementCents;
    };

    const formatSignedEuroCents = (cents) => `${cents < 0 ? "−" : "+"} ${formatEuroCents(Math.abs(cents))}`;
    // Prix au litre : toujours deux decimales (2,32 EUR/L, 1,80 EUR/L).
    const formatLiterPrice = (cents) => `${((Number(cents) || 0) / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 3 })} €/L`;

    // "14h", "14h30", "14:30", "9" -> { h, min } ; null si illisible.
    const parseHourMinutes = (value) => {
        const match = String(value || '').match(/^\s*(\d{1,2})\s*[hH:.]?\s*(\d{1,2})?/);
        if (!match) {
            return null;
        }
        const h = Number(match[1]);
        const min = match[2] ? Number(match[2]) : 0;
        return h > 23 || min > 59 ? null : { h, min };
    };

    // Heure de depart du trajet estime : debut de location (ou fin pour une reprise seule) ; null si passee ou non renseignee.
    const getDeliveryDepartureDate = () => {
        const dates = Array.isArray(formik.values.dates) ? formik.values.dates : [];
        const pickupOnly = formik.values.deliveryId === 'PickupOnly';
        const baseDate = pickupOnly ? (dates[1] || dates[0]) : dates[0];
        const hour = parseHourMinutes(pickupOnly ? (formik.values.rentalHourEnd || formik.values.rentalHour) : formik.values.rentalHour);
        if (!baseDate || !hour) {
            return null;
        }
        const date = new Date(baseDate);
        if (Number.isNaN(date.getTime())) {
            return null;
        }
        date.setHours(hour.h, hour.min, 0, 0);
        return date.getTime() > Date.now() + 5 * 60 * 1000 ? date : null;
    };

    const formatDepartureLabel = (value) => {
        const date = value ? new Date(value) : null;
        if (!date || Number.isNaN(date.getTime())) {
            return '';
        }
        return date.toLocaleString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
    };

    const formatEuroCents = (cents) => `${((Number(cents) || 0) / 100).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} €`;

    const formatBillableUnits = (proposal) => proposal?.unitLabel === "km"
        ? `${Number(proposal.billableUnits || 0).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} km`
        : `${Math.round(Number(proposal?.billableUnits || 0))} min`;

    const formatTripDistance = (meters) => {
        const value = Number(meters) || 0;
        return value >= 1000
            ? `${(value / 1000).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} km`
            : `${value} m`;
    };

    const formatTripDuration = (seconds) => {
        const minutes = Math.ceil((Number(seconds) || 0) / 60);
        if (minutes < 60) {
            return `${minutes} min`;
        }
        const hours = Math.floor(minutes / 60);
        const rest = minutes % 60;
        return rest ? `${hours} h ${String(rest).padStart(2, "0")}` : `${hours} h`;
    };

    const buildDeliveryMapsUrl = (origin, destination) => {
        if (!origin || !destination) {
            return null;
        }
        return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}&travelmode=driving`;
    };

    // Toute modification de l'adresse invalide l'estimation (affichee et memorisee).
    const setDeliveryAddressValue = (value) => {
        const nextValue = value ?? '';
        formik.setFieldValue('deliveryAddress', nextValue);
        if (deliveryEstimate && deliveryEstimate.address !== nextValue) {
            setDeliveryEstimate(null);
            setDeliveryEstimateError(null);
        }
        if (String(formik.values.deliveryDistanceMeters ?? '') !== '' && (!deliveryEstimate || deliveryEstimate.address !== nextValue)) {
            formik.setFieldValue('deliveryDistanceMeters', '');
            formik.setFieldValue('deliveryDurationSeconds', '');
            formik.setFieldValue('deliveryOriginWarehouseId', '');
        }
    };

    const searchDeliveryAddress = async (event) => {
        try {
            const response = await autocompleteDeliveryAddress(event.query);
            const suggestions = Array.isArray(response?.suggestions) ? response.suggestions : [];
            setDeliveryAddressSuggestions(suggestions.map((suggestion) => suggestion.description).filter(Boolean));
            // Google a refuse l'appel (cle, quota...) : on le dit plutot que de laisser croire que rien ne se passe.
            setDeliveryAutocompleteError(suggestions.length === 0 && response?.error ? response.error : null);
        } catch (error) {
            setDeliveryAddressSuggestions([]);
            setDeliveryAutocompleteError("Suggestions d'adresses indisponibles pour le moment.");
        }
    };

    const runDeliveryEstimate = async () => {
        const address = String(formik.values.deliveryAddress || '').trim();
        if (!address) {
            setDeliveryEstimateError("Renseignez l'adresse de livraison/reprise avant d'estimer.");
            return;
        }

        setDeliveryEstimateLoading(true);
        setDeliveryEstimateError(null);
        try {
            const warehouseId = deliveryOriginKey.startsWith('warehouse:') ? Number(deliveryOriginKey.split(':')[1]) : null;
            const departure = getDeliveryDepartureDate();
            const departureRequested = departure ? departure.toISOString() : null;
            const result = await estimateDeliveryFees({
                Address: address,
                Delivery: formik.values.deliveryId || 'DeliveryWithPickup',
                WarehouseId: warehouseId || null,
                DepartureTime: departureRequested
            });

            if (!result || result.success === false) {
                setDeliveryEstimate(null);
                setDeliveryEstimateError(result?.message || "Estimation impossible pour le moment.");
                return;
            }

            setDeliveryEstimate({ ...result, address, departureRequested });
            setDeliverySelectedMode(result.recommendedMode || result.mode || "PerMinute");
        } catch (error) {
            setDeliveryEstimate(null);
            setDeliveryEstimateError(error?.message || "Estimation impossible pour le moment.");
        } finally {
            setDeliveryEstimateLoading(false);
        }
    };

    const applyDeliveryEstimate = () => {
        if (!deliveryEstimate) {
            return;
        }
        const totalCents = computeDeliveryEstimateTotalCents(deliveryEstimate, formik.values.deliveryId, deliverySelectedMode);
        formik.setFieldValue('deliveryFees', formatMoneyValue(totalCents / 100));
        formik.setFieldValue('deliveryDistanceMeters', deliveryEstimate.distanceMeters || '');
        formik.setFieldValue('deliveryDurationSeconds', deliveryEstimate.durationSeconds || '');
        formik.setFieldValue('deliveryOriginWarehouseId', deliveryEstimate.warehouseId || '');
    };

    const getAdvancePaymentBaseAmount = () => {
        const customPrice = parseMoneyValue(formik.values.customPrice);
        if (customPrice > 0) {
            return customPrice;
        }

        return parseMoneyValue(actualPrice);
    };

    // Formik ---------------------
    const allowedDepositTypes = Array.isArray(settings?.allowedDepositTypes) && settings.allowedDepositTypes.length
        ? settings.allowedDepositTypes
        : ["CB", "Cash", "Check", "BankTransfer"];
    const defaultDepositType = settings?.defaultDepositType && allowedDepositTypes.includes(settings.defaultDepositType)
        ? settings.defaultDepositType
        : "";

    const radioBtns = [
        {
            id: 'cash',
            name: 'cash',
            value: 'Cash',
            inputId: 'f1',
            trad: 'Esp\u00e8ces'
        },
        {
            id: 'Check',
            name: 'Check',
            value: 'Check',
            inputId: 'f3',
            trad: 'Ch\u00e8que'
        },
        {
            id: 'CB',
            name: 'CB',
            value: 'CB',
            inputId: 'f2',
            trad: 'Empreinte CB'
        },
        {
            id: 'BankTransfer',
            name: 'BankTransfer',
            value: 'BankTransfer',
            inputId: 'f4',
            trad: 'Virement instantan\u00e9'
        }
    ].filter((btn) => allowedDepositTypes.includes(btn.value));

    let materialsList, serviceId, deliveryId, datesFormatted, endHour,startHour, rentalId = "";
    let fname, lname, birth, birthplace, phone, email, address = "";
    let deliveryAddress = "";
    let deliveryFees = "";
    let deliveryDistanceMeters = "", deliveryDurationSeconds = "", deliveryOriginWarehouseId = "";
    let clientType = "Private", companyName = "", siret = "";
    let rentalContacts = [];
    let options, customPrice, comment, deposit, permanentLinkDeposit = "";
    let advancePaymentAmountCentsNeeded = 0;
    let initialAdvancePaymentCollectionMode = "SumUp";
    if (rental) {
        

        rentalId = rental.rentalPublicId;
        materialsList = rental.materialList;
        serviceId = rental.servicePublicId;
        deliveryId = rental.delivery;

        let start = new Date(rental.startDate);
        let end = new Date(rental.endDate);
        datesFormatted = [start, end];

        startHour = start.getHours() + ":" + start.getMinutes();
        if (startHour === "0:0")
            startHour = "";
        endHour = end.getHours() + ":" + end.getMinutes();
        if (endHour === "0:0")
            endHour = "";
        fname = rental.clientFirstname;
        lname = rental.clientLastname;
        birth = (rental.clientBirthDate) ? new Date(rental.clientBirthDate) : null;
        birthplace = rental.clientBirthplace;
        phone = rental.clientPhone;
        email = rental.clientEmail;
        address = rental.clientAddress;
        deliveryAddress = rental.deliveryAddress || rental.clientAddress;
        if (rental.deliveryFeesCents) {
            deliveryFees = rental.deliveryFeesCents / 100;
        }
        if (rental.deliveryDistanceMeters) {
            deliveryDistanceMeters = rental.deliveryDistanceMeters;
        }
        if (rental.deliveryDurationSeconds) {
            deliveryDurationSeconds = rental.deliveryDurationSeconds;
        }
        if (rental.deliveryOriginWarehouseId) {
            deliveryOriginWarehouseId = rental.deliveryOriginWarehouseId;
        }
        clientType = rental.clientType || "Private";
        companyName = rental.companyName || "";
        siret = rental.siret || "";
        rentalContacts = rental.rentalContacts || [];

        options = (rental.options) ? rental.options : "";
        if (rental.customPrice) {
            customPrice = rental.customPrice / 100;
        }
        if (rental.advancePaymentAmountCentsNeeded) {
            advancePaymentAmountCentsNeeded = rental.advancePaymentAmountCentsNeeded / 100;
        }
        initialAdvancePaymentCollectionMode = rental.advancePaymentCollectionMode || "SumUp";
        comment = (rental.comment) ? rental.comment : "";
        deposit = rental.depositType;
        permanentLinkDeposit = rental.permanentLinkDeposit

        
    } else {


        if (preselectClient) {
            fname = preselectClient.firstname;
            lname = preselectClient.lastname;
            birth = (preselectClient.birthdate) ? new Date(preselectClient.birthdate) : null;
            birthplace = preselectClient.birthplace;
            phone = preselectClient.phone;
            email = preselectClient.email;
            address = preselectClient.address;
            deliveryAddress = preselectClient.address;
            clientType = preselectClient.clientType || "Private";
            companyName = preselectClient.companyName || "";
            siret = preselectClient.siret || "";
            if (preselectClient.lastRental) {
                deposit = allowedDepositTypes.includes(preselectClient.lastRental.depositType)
                    ? preselectClient.lastRental.depositType
                    : defaultDepositType;
            }   
        }

 
    }

    if (!rental && !deposit && defaultDepositType) {
        deposit = defaultDepositType;
    }


    const onTagsChangeTools = (values) => {
        if (values) {
            resetActualPrice();
            setSelectedMaterials(values);
            setMaterialQuantityErrors({});
            setMaterialQuantities((previousQuantities) => {
                const nextQuantities = {};
                values.forEach((materialId) => {
                    nextQuantities[materialId] = previousQuantities[materialId] || 1;
                });

                const expandedMaterials = expandMaterialsFromQuantities(nextQuantities);
                formik.setFieldValue('material', expandedMaterials);
                setDepositAmount(calculateDepositAmount(expandedMaterials, optionscompleteTools));

                var advancedPayment = 0;
                for (let i = 0; i < expandedMaterials.length; i++) {
                    var toolA = optionscompleteTools.find(x => x.value === expandedMaterials[i]);
                    if (toolA && toolA.advancedPaymentPercentRequired)
                        advancedPayment = toolA.advancedPaymentPercentRequired;
                }
                if (advancedPayment > 0) {
                    setAvailableAdvancePayment("1");
                    setSignatureRequired("1");
                }

                return nextQuantities;
            });

        }
    }

    const onMaterialQuantityChange = (materialId, quantity) => {
        const cleanedQuantity = quantity === '' ? '' : Math.floor(Number(quantity));
        resetActualPrice();

        setMaterialQuantities((previousQuantities) => {
            const nextQuantities = {
                ...previousQuantities,
                [materialId]: cleanedQuantity
            };

            const expandedMaterials = getExpandedMaterialsFromSelection(selectedMaterials, nextQuantities);

            formik.setFieldValue('material', expandedMaterials);
            setDepositAmount(calculateDepositAmount(expandedMaterials, optionscompleteTools));

            setMaterialQuantityErrors((previousErrors) => {
                const nextErrors = { ...previousErrors };
                if (isValidQuantity(cleanedQuantity)) {
                    delete nextErrors[materialId];
                } else {
                    nextErrors[materialId] = true;
                }

                return nextErrors;
            });

            return nextQuantities;
        });
    };

    const onOptionsChange = (values) => {
        setSelectedOptions(values);
        setOptionQuantityErrors({});
        setOptionQuantities((previousQuantities) => {
            const nextQuantities = {};
            (values || []).forEach((option) => {
                const optionId = getOptionId(option);
                if (!optionId) {
                    return;
                }
                nextQuantities[optionId] = previousQuantities[optionId] || 1;
            });
            return nextQuantities;
        });
    };

    const onOptionQuantityChange = (optionId, quantity) => {
        const cleanedQuantity = quantity === '' ? '' : Math.floor(Number(quantity));

        setOptionQuantities((previousQuantities) => {
            const nextQuantities = {
                ...previousQuantities,
                [optionId]: cleanedQuantity
            };

            setOptionQuantityErrors((previousErrors) => {
                const nextErrors = { ...previousErrors };
                if (isValidQuantity(cleanedQuantity)) {
                    delete nextErrors[optionId];
                } else {
                    nextErrors[optionId] = true;
                }
                return nextErrors;
            });

            return nextQuantities;
        });
    };




    useEffect(() => {
        if (rental) {
            setOpenTools(true);
            setAvailableDeposit(rental.availableDeposit)
            setAvailableAdvancePayment((rental.advancePaymentAmountCentsNeeded > 0)? "1":"0")
            setAdvancePaymentCollectionMode(rental.advancePaymentCollectionMode || "SumUp");
            setSignatureRequired(rental.signatureRequired ? "1" : "0");
        }
        if (rental && rental.permanentLinkDeposit) {
            setPermanentLinkDepositBloc(true)
        }
        if (preselectMaterial) {
            setOpenTools(true);

            var material = [];
            material.push(preselectMaterial.publicId)
            materialsList = material;

            onTagsChangeTools(material)
            setMaterialQuantities(buildMaterialQuantities(material));

            setDepositAmount(preselectMaterial.deposit / 100)
            if (preselectMaterial.advancedPaymentPercentRequired > 0) {
                setAvailableAdvancePayment("1");
                setSignatureRequired("1");
            }
        }
    }, []);

    useEffect(() => {
        if (rental) {
            return;
        }

        hydratingDraftRef.current = true;

        if (localDraft) {
            const materialValues = Array.isArray(localDraft.values?.material) ? localDraft.values.material : [];
            const nextValues = {
                ...baseFormValues,
                ...localDraft.values,
                material: materialValues,
                dates: Array.isArray(localDraft.values?.dates)
                    ? localDraft.values.dates.map((date) => (date ? new Date(date) : null))
                    : localDraft.values?.dates || baseFormValues.dates,
                birthdate: localDraft.values?.birthdate ? new Date(localDraft.values.birthdate) : null
            };

            formik.resetForm({ values: nextValues });

            if (materialValues.length) {
                setSelectedMaterials(Array.from(new Set(materialValues)));
                setMaterialQuantities(buildMaterialQuantities(materialValues));
                setOpenTools(true);
                GetMaterialsOptions(materialValues);
            } else {
                setSelectedMaterials(null);
                setMaterialQuantities({});
                setMaterialQuantityErrors({});
            }

            setAvailableDeposit(localDraft.availableDeposit || "1");
            setAvailableAdvancePayment(localDraft.availableAdvancePayment || "0");
            setAdvancePaymentCollectionMode(localDraft.advancePaymentCollectionMode || localDraft.values?.advancePaymentCollectionMode || "SumUp");
            setSignatureRequired(localDraft.signatureRequired ?? "0");
            setLocalDraftOptionIds(localDraft.selectedOptionIds || []);
            if (!localDraft.selectedOptionIds?.length) {
                setSelectedOptions([]);
                setOptionQuantities({});
                setOptionQuantityErrors({});
            }
            setLocalDraftId(localDraft.id);
            localDraftIdRef.current = localDraft.id;
            setLocalDraftMeta({
                createdAt: localDraft.createdAt ?? null,
                updatedAt: localDraft.updatedAt ?? null
            });
        } else {
            formik.resetForm({ values: baseFormValues });
            setSelectedMaterials(null);
            setMaterialQuantities({});
            setMaterialQuantityErrors({});
            setSelectedOptions([]);
            setOptionQuantities({});
            setOptionQuantityErrors({});
            setLocalDraftOptionIds([]);
            setLocalDraftId(null);
            localDraftIdRef.current = null;
            setLocalDraftMeta({ createdAt: null, updatedAt: null });
            setAvailableDeposit("1");
            setAvailableAdvancePayment((settings?.defaultAdvancePaymentPercent ?? 0) > 0 ? "1" : "0");
            setAdvancePaymentCollectionMode("SumUp");
            setSignatureRequired(settings?.requireElectronicSignatureByDefault ? "1" : "0");
        }

        window.setTimeout(() => {
            hydratingDraftRef.current = false;
        }, 0);
    }, [localDraft?.id, rental]);

    useEffect(() => {
        const expandedMaterials = getExpandedMaterialsFromSelection(selectedMaterials, materialQuantities);
        const nextDepositAmount = calculateDepositAmount(expandedMaterials, optionscompleteTools);
        if (nextDepositAmount !== undefined) {
            setDepositAmount(nextDepositAmount);
        }
    }, [selectedMaterials, materialQuantities, optionscompleteTools]);

    useEffect(() => {
        if (Object.keys(materialQuantityErrors).length > 0) {
            setShowQuantityModal(true);
        }
    }, [materialQuantityErrors]);

    useMountEffect(() => {
        if (msgs.current) {
            msgs.current.clear();
            msgs.current.show([
                   
                { sticky: true, severity: 'warn', summary: 'Attention', detail: 'Vous avez atteint le nombre maximal de locations autorisées sur la période !', closable: false },

            ]);
        }
    });

    const baseFormValues = {
            material: materialsList ?? '',
            serviceId: serviceId ?? '',
            deliveryId: rental ? (deliveryId ?? 'NoDelivery') : '',
            rentalHour: startHour ?? '',
            rentalHourEnd: endHour ?? '',
            firstname: fname ?? '',
            lastname: lname ?? '',
            birthdate: birth ?? null,
            birthplace: birthplace ?? '',
            phone: phone ?? '',
            email: email ?? '',
            clientType: clientType ?? 'Private',
            companyName: companyName ?? '',
            siret: siret ?? '',
            options: options ?? '',
            customPrice: customPrice ?? '',
            advancePaymentAmountCentsNeeded: advancePaymentAmountCentsNeeded??'',
            advancePaymentCollectionMode: initialAdvancePaymentCollectionMode,
            dates: datesFormatted ?? '',
            deposit: deposit ?? '',
            address: address ?? '',
            deliveryAddress: deliveryAddress ?? '',
            deliveryFees: deliveryFees ?? '',
            deliveryDistanceMeters: deliveryDistanceMeters ?? '',
            deliveryDurationSeconds: deliveryDurationSeconds ?? '',
            deliveryOriginWarehouseId: deliveryOriginWarehouseId ?? '',
            comment: comment ?? '',
            permanentLinkDeposit: permanentLinkDeposit ?? '',
            rentalContacts: rentalContacts
    };

    const addRentalContact = () => {
        formik.setFieldValue('rentalContacts', [
            ...(Array.isArray(formik.values.rentalContacts) ? formik.values.rentalContacts : []),
            { name: '', role: '', email: '', phone: '' }
        ]);
    };

    const updateRentalContact = (index, field, value) => {
        const contacts = [...(Array.isArray(formik.values.rentalContacts) ? formik.values.rentalContacts : [])];
        contacts[index] = { ...contacts[index], [field]: value };
        formik.setFieldValue('rentalContacts', contacts);
    };

    const removeRentalContact = (index) => {
        formik.setFieldValue('rentalContacts', (Array.isArray(formik.values.rentalContacts) ? formik.values.rentalContacts : []).filter((_, contactIndex) => contactIndex !== index));
    };

    useEffect(() => {
        localDraftIdRef.current = localDraftId;
    }, [localDraftId]);

    const formik = useFormik({
        initialValues: baseFormValues,
        validate: (data) => {
            let errors = {};
            if (!data.material) 
                errors.material = 'Material is required.';
            if (!data.serviceId) 
                errors.serviceId = 'Service is required.';
            if (!data.deliveryId) {
                errors.deliveryId = 'Le mode de livraison est obligatoire.';
            }
            if (!data.rentalHour) {
                errors.rentalHour = 'Hour is required.';
            }
            if (!data.firstname) {
                errors.firstname = 'Firstname is required.';
            }
            if (!data.lastname) {
                errors.lastname = 'Lastname is required.';
            }
            if (data.clientType === "Professional" && !data.companyName) {
                errors.companyName = 'Le nom de la société est obligatoire.';
            }

            if (!String(data.phone ?? '').trim()) {
                errors.phone = 'Le téléphone est obligatoire.';
            } else if (isPhoneTooLong(data.phone)) {
                errors.phone = INVALID_PHONE_MESSAGE;
            }
            if (!data.email) {
                errors.email = 'Email is required.';
            }
            if ((Array.isArray(data.rentalContacts) ? data.rentalContacts : []).some((contact) => !contact.name?.trim())) {
                errors.rentalContacts = 'Chaque contact doit avoir un nom.';
            }
            if (!data.dates) {
                errors.dates = 'Dates is required.';
            }
            if (!data.deposit && availableDeposit === "1") {
                errors.deposit = 'Le choix de la caution est obligatoire.';
            }

            if (hasDeliveryOrPickup(data.deliveryId) && !data.deliveryAddress) {
                errors.deliveryAddress = 'L\'adresse de livraison/reprise est obligatoire !';
            }
            if (hasDeliveryOrPickup(data.deliveryId) && String(data.deliveryFees ?? '').trim() === '') {
                errors.deliveryFees = 'Obligatoire.';
            }
            if (hasDeliveryOrPickup(data.deliveryId) && parseMoneyValue(data.deliveryFees) < 0) {
                errors.deliveryFees = 'Les frais doivent être supérieurs ou égaux à 0.';
            }
            if (availableAdvancePayment === "1" && parseMoneyValue(data.advancePaymentAmountCentsNeeded) <= 0)
                errors.advancePaymentAmountCentsNeeded = "Le montant de l'acompte est obligatoire";
            if (availableAdvancePayment === "1" && !data.advancePaymentCollectionMode)
                errors.advancePaymentCollectionMode = "Le mode d'encaissement est obligatoire";

            

            return errors;
        },
        onSubmit: async (data) => {
            setIsSaving(true);
            const expandedOptionIds = getExpandedOptionIdsFromSelection(selectedOptions || [], optionQuantities);
            const missingQuantityOptionIds = (selectedOptions || [])
                .filter((option) => !isValidQuantity(optionQuantities[getOptionId(option)]))
                .map((option) => getOptionId(option));

            if (missingQuantityOptionIds.length > 0) {
                setOptionQuantityErrors(missingQuantityOptionIds.reduce((acc, optionId) => {
                    acc[optionId] = true;
                    return acc;
                }, {}));
                send("warning", "Quantités invalides : veuillez renseigner une quantité valide pour les options sélectionnées.")
                notify();
                setIsSaving(false);
                return;
            }

            data.selectedOptions = expandedOptionIds.join(',');

            const effectiveSelectedMaterials = (selectedMaterials && selectedMaterials.length > 0)
                ? selectedMaterials
                : (Array.isArray(data.material) ? data.material : []);

            const missingQuantityMaterialIds = effectiveSelectedMaterials.filter((materialId) => !isValidQuantity(materialQuantities[materialId]));
            if (missingQuantityMaterialIds.length > 0) {
                const missingQuantityMaterialNames = missingQuantityMaterialIds.map((materialId) => {
                    const tool = optionscompleteTools.find((item) => item.value === materialId);
                    return tool?.name || materialId;
                });

                setMaterialQuantityErrors(missingQuantityMaterialIds.reduce((acc, materialId) => {
                    acc[materialId] = true;
                    return acc;
                }, {}));

                send("warning", `Quantités invalides : veuillez renseigner une quantité valide pour ${missingQuantityMaterialNames.join(', ')}.`)
                notify();
                setIsSaving(false);
                return;
            }

            const expandedMaterials = getExpandedMaterialsFromSelection(effectiveSelectedMaterials, materialQuantities);
            data.material = expandedMaterials;
            if (data.clientType === "Professional") {
                data.birthdate = "";
                data.birthplace = "";
            }

            let errorAvalaible = false
            let errorDeposit = false
            let a = await isAvalaibleTool(data, rentalId);
            if (a.status === 200)
                errorAvalaible = false;
            else if (a.status === 400) {
                errorAvalaible = true;
                send("warning", a.message)
                notify();
            }
                
            else if (a.status === 500) { 
                errorAvalaible = true;
                send("warning", a.message)
                notify();
                
            }
            

            if (data.deposit === 'CB') {

                if (acc.stripeStatus !== "AccountCreated") {
                    send("warning", "Votre compte Stripe n'est pas configuré pour recevoir des cautions ! Rendez vous sur votre compte pour commencer ou choisissez un autre mode de caution !")
                    notify();
                    errorDeposit = true;
                } 

                if (!data.permanentLinkDeposit) {
                    let needed = await permanentLinkNeeded(data.dates[0].toUTCString(), data.dates[1].toUTCString())
                    if (needed) {
                        errorDeposit = true;
                        send("warning", "Vous devez renseigner un lien de caution !")
                        notify();
                    }
                }

               
            }
            data.availableDeposit = availableDeposit;
            data.signatureRequired = signatureRequired;
            data.advancePaymentCollectionMode = advancePaymentCollectionMode;
            if (availableAdvancePayment === "0") {
                data.advancePaymentAmountCentsNeeded = "0";
            }
            if (availableAdvancePayment === "1" && advancePaymentCollectionMode === "Stripe" && acc.stripeStatus !== "AccountCreated") {
                send("warning", "Votre compte Stripe n'est pas configuré pour encaisser l'acompte. Choisissez SumUp ou un encaissement hors plateforme.")
                notify();
                setIsSaving(false);
                return;
            }
            if (!hasDeliveryOrPickup(data.deliveryId)) {
                data.deliveryAddress = "";
                data.deliveryFees = "0";
                data.deliveryDistanceMeters = "";
                data.deliveryDurationSeconds = "";
                data.deliveryOriginWarehouseId = "";
            }
            const submittedRentalContacts = JSON.stringify((Array.isArray(data.rentalContacts) ? data.rentalContacts : []).map((contact) => ({
                name: contact.name?.trim(),
                role: contact.role?.trim(),
                email: contact.email?.trim(),
                phone: contact.phone?.trim()
            })));

            if (!errorAvalaible && !errorDeposit) {
                submit({ ...data, rentalContacts: submittedRentalContacts, localDraftId: localDraftId || "" }, { method: "post" })
            } else {
                setIsSaving(false);
            }
        }
    });

    useEffect(() => {
        const percent = getRequiredAdvancePercent(selectedMaterials);
        setAdvancePercentHint(percent > 0 ? percent : null);

        if (percent <= 0) {
            return;
        }

        setAvailableAdvancePayment("1");
        setSignatureRequired("1");

        const currentAdvanceAmount = parseMoneyValue(formik.values.advancePaymentAmountCentsNeeded);
        const lastSuggestedAmount = parseMoneyValue(lastSuggestedAdvanceAmount.current);
        if (currentAdvanceAmount > 0 && currentAdvanceAmount !== lastSuggestedAmount) {
            return;
        }

        const baseAmount = getAdvancePaymentBaseAmount();
        if (baseAmount <= 0) {
            return;
        }

        const suggestedAdvance = formatMoneyValue((baseAmount * percent) / 100);
        lastSuggestedAdvanceAmount.current = suggestedAdvance;
        formik.setFieldValue('advancePaymentAmountCentsNeeded', suggestedAdvance);
    }, [selectedMaterials, actualPrice, formik.values.customPrice, formik.values.deliveryId, formik.values.deliveryFees, formik.values.advancePaymentAmountCentsNeeded, optionscompleteTools]);

    const selectedService = formattedServices.find((item) => item.value === formik.values.serviceId);
    const isBricolibService = (selectedService?.name || "").toLowerCase().includes("bricolib");


    const onBricolibPdfUpload = async (event) => {
        const file = event.target.files?.[0];
        event.target.value = "";

        if (!file) {
            return;
        }

        if (!file.type.includes("pdf") && !file.name.toLowerCase().endsWith(".pdf")) {
            send("warning", "Veuillez importer un fichier PDF.");
            notify();
            return;
        }

        setIsExtractingBricolibPdf(true);
        try {
            const extracted = await extractBricolibContract(file);
            if (!extracted) {
                send("warning", "Impossible d'extraire les données du contrat Bricolib.");
                notify();
                return;
            }

            if (extracted.firstname) formik.setFieldValue('firstname', extracted.firstname);
            if (extracted.lastname) formik.setFieldValue('lastname', extracted.lastname);
            if (extracted.address) formik.setFieldValue('address', extracted.address);
            if (extracted.phone) formik.setFieldValue('phone', extracted.phone);
            if (extracted.email) formik.setFieldValue('email', extracted.email);

            const startDate = parseFrenchDateToLocalDate(extracted.startDate);
            const endDate = parseFrenchDateToLocalDate(extracted.endDate);
            const hasDateRangeSelected = Array.isArray(formik.values.dates)
                && formik.values.dates.length >= 2
                && formik.values.dates[0]
                && formik.values.dates[1];
            if (!hasDateRangeSelected && startDate && endDate) {
                formik.setFieldValue('dates', [startDate, endDate]);
            }

            const hasAlreadySelectedTools = Array.isArray(selectedMaterials) && selectedMaterials.length > 0;
            if (!hasAlreadySelectedTools && extracted.tool) {
                const tools = await ensureToolsLoaded();
                const matchedToolId = findToolIdFromPdf(extracted.tool, tools);
                if (matchedToolId) {
                    onTagsChangeTools([matchedToolId]);
                }
            }

            setShowBricolibModal(false);

            send("success", "Contrat Bricolib analysé : les champs locataire ont été préremplis.");
            notify();
        } catch (error) {
            send("warning", "Erreur lors de l'analyse du contrat Bricolib.");
            notify();
        } finally {
            setIsExtractingBricolibPdf(false);
        }
    };

    async function selectedDeposit(val) {
        if (val === 'CB' && formik.values.dates[0] && formik.values.dates[1]) {
            let needed = await permanentLinkNeeded(formik.values.dates[0].toUTCString(), formik.values.dates[1].toUTCString())
            setPermanentLinkDepositBloc(Boolean(needed));
               
        } else {
            // on fait disparaitre permanentLinkDepositBloc
            setPermanentLinkDepositBloc(false)
        }            
    }

    async function selectedDates(val) {

        if (formik.values.deposit === 'CB' && val[0] && val[1]) {

            let st = new Date(val[0]);
            st.setHours(5);
            let en = new Date(val[1]);
            en.setHours(5);

            let needed = await permanentLinkNeeded(st.toUTCString(), en.toUTCString())
            setPermanentLinkDepositBloc(Boolean(needed));
        } else {
            // on fait disparaitre permanentLinkDepositBloc
            setPermanentLinkDepositBloc(false)
        }
       


    }


    async function getActualPrice() {
        // get hour
        var hour = formik.values.rentalHour;

        if (!Array.isArray(formik.values.dates) || !formik.values.dates[0] || !formik.values.dates[1]) {
            return 0;
        }

        // get dates
        var st = new Date(formik.values.dates[0]);
        st.setHours(5);
        var en = new Date(formik.values.dates[1]);
        en.setHours(5);

        // si l'un des deux est undefined on ne fait rien
        if (!hour || !Array.isArray(selectedMaterials) || selectedMaterials.length === 0) {
            return 0;
        }

        const materialsForPrice = getExpandedMaterialsFromSelection(selectedMaterials, materialQuantities);
        const responses = await Promise.all(
            materialsForPrice
                .filter((mat) => Boolean(mat))
                .map((mat) => getPrice(st, en, hour, mat))
        );

        const totalCents = responses.reduce((total, response) => total + (response?.totalPriceCents || 0), 0)
            + getSelectedOptionsTotalCents(selectedOptions, optionQuantities)
            + Math.round(getCurrentDeliveryFeesAmount() * 100);
        const total = totalCents / 100;
        setActualPrice(total);
        return total;
    };

    async function resetActualPrice() {
        setActualPrice()
    };

    const selectedMaterialSignature = (selectedMaterials || []).join(',');
    const materialQuantitySignature = JSON.stringify(materialQuantities || {});
    const selectedOptionSignature = (selectedOptions || []).map((option) => getOptionId(option)).join(',');
    const optionQuantitySignature = JSON.stringify(optionQuantities || {});
    const dateSignature = Array.isArray(formik.values.dates)
        ? formik.values.dates.map((date) => date ? new Date(date).getTime() : '').join(',')
        : '';

    useEffect(() => {
        const hasDates = Array.isArray(formik.values.dates) && formik.values.dates[0] && formik.values.dates[1];
        const hasMaterials = Array.isArray(selectedMaterials) && selectedMaterials.length > 0;
        if (!hasDates || !formik.values.rentalHour || !hasMaterials) {
            return;
        }

        getActualPrice();
    }, [selectedMaterialSignature, materialQuantitySignature, selectedOptionSignature, optionQuantitySignature, dateSignature, formik.values.rentalHour, formik.values.deliveryId, formik.values.deliveryFees]);

    // Points de depart de l'estimation (adresse du loueur + entrepots) ; l'entrepot memorise sur la location est repris.
    useEffect(() => {
        let active = true;
        getDeliveryEstimateOrigins()
            .then((response) => {
                if (!active) {
                    return;
                }
                const origins = Array.isArray(response?.origins) ? response.origins : [];
                setDeliveryOrigins(origins);
                const storedWarehouseId = Number(formik.values.deliveryOriginWarehouseId);
                const defaultKey = response?.defaultKey;
                if (storedWarehouseId && origins.some((origin) => origin.warehouseId === storedWarehouseId)) {
                    setDeliveryOriginKey(`warehouse:${storedWarehouseId}`);
                    deliveryOriginTouchedRef.current = true;
                } else if (defaultKey && defaultKey !== 'auto' && origins.some((origin) => origin.key === defaultKey)) {
                    // Point de depart par defaut des parametres : il prime sur l'entrepot du materiel.
                    setDeliveryOriginKey(defaultKey);
                    deliveryOriginTouchedRef.current = true;
                }
            })
            .catch(() => {
                // Estimation indisponible : le formulaire reste utilisable en saisie manuelle.
            });
        return () => {
            active = false;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Depart par defaut = entrepot du premier materiel selectionne, tant que l'utilisateur n'a pas choisi lui-meme.
    useEffect(() => {
        if (deliveryOriginTouchedRef.current || !Array.isArray(selectedMaterials) || selectedMaterials.length === 0 || deliveryOrigins.length === 0) {
            return;
        }
        const firstTool = optionscompleteTools.find((tool) => tool.value === selectedMaterials[0]);
        const warehouseId = Array.isArray(firstTool?.warehouseIds) ? firstTool.warehouseIds[0] : null;
        if (warehouseId && deliveryOrigins.some((origin) => origin.warehouseId === warehouseId)) {
            setDeliveryOriginKey(`warehouse:${warehouseId}`);
        }
    }, [selectedMaterials, optionscompleteTools, deliveryOrigins]);

    const fillAdvancePaymentAmountIfNeeded = async () => {
        const percent = getRequiredAdvancePercent(selectedMaterials);
        if (percent <= 0) {
            setAdvancePercentHint(null);
            return;
        }

        setAdvancePercentHint(percent);

        const currentAdvanceAmount = parseMoneyValue(formik.values.advancePaymentAmountCentsNeeded);
        const lastSuggestedAmount = parseMoneyValue(lastSuggestedAdvanceAmount.current);
        if (currentAdvanceAmount > 0 && currentAdvanceAmount !== lastSuggestedAmount) {
            return;
        }

        let baseAmount = getAdvancePaymentBaseAmount();
        if (baseAmount <= 0) {
            baseAmount = await getActualPrice();
        }

        if (baseAmount <= 0) {
            return;
        }

        const suggestedAdvance = formatMoneyValue((baseAmount * percent) / 100);
        lastSuggestedAdvanceAmount.current = suggestedAdvance;
        formik.setFieldValue('advancePaymentAmountCentsNeeded', suggestedAdvance);
    };

    const customRentalPriceAmount = parseMoneyValue(formik.values.customPrice);
    const rentalTotalAmount = customRentalPriceAmount > 0
        ? customRentalPriceAmount
        : parseMoneyValue(actualPrice);

    const deliveryEstimateTotalCents = computeDeliveryEstimateTotalCents(deliveryEstimate, formik.values.deliveryId, deliverySelectedMode);
    const deliveryEstimateApplied = Boolean(deliveryEstimate)
        && Math.round(parseMoneyValue(formik.values.deliveryFees) * 100) === deliveryEstimateTotalCents
        && Number(formik.values.deliveryDistanceMeters) === Number(deliveryEstimate.distanceMeters);
    const deliveryProposals = Array.isArray(deliveryEstimate?.proposals) ? deliveryEstimate.proposals : [];
    const deliveryProposalTotals = deliveryProposals.map((proposal) => computeDeliveryEstimateTotalCents(deliveryEstimate, formik.values.deliveryId, proposal.mode));
    const deliveryBestTotalCents = deliveryProposalTotals.length ? Math.max(...deliveryProposalTotals) : 0;
    const deliveryDepartureDate = getDeliveryDepartureDate();
    const deliveryDepartureIso = deliveryDepartureDate ? deliveryDepartureDate.toISOString() : null;
    // Dates ou heure changees depuis l'estimation : le trafic prevu n'est plus le bon.
    const deliveryEstimateStale = Boolean(deliveryEstimate) && (deliveryEstimate.departureRequested || null) !== deliveryDepartureIso;
    // Vehicule de livraison : passages pendant une indisponibilite du camion, ou livraisons prevues pendant qu'il est loue.
    const deliveryVehiclePeriod = (() => {
        const dates = Array.isArray(formik.values.dates) ? formik.values.dates : [];
        const startHour = parseHourMinutes(formik.values.rentalHour);
        const endHour = parseHourMinutes(formik.values.rentalHourEnd || formik.values.rentalHour);
        if (!dates[0] || !startHour || !endHour) {
            return { start: null, end: null };
        }
        const start = new Date(dates[0]);
        const end = new Date(dates[1] || dates[0]);
        if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
            return { start: null, end: null };
        }
        start.setHours(startHour.h, startHour.min, 0, 0);
        end.setHours(endHour.h, endHour.min, 0, 0);
        return { start, end };
    })();
    const deliveryVehicleCheck = useDeliveryVehicleCheck({
        start: deliveryVehiclePeriod.start,
        end: deliveryVehiclePeriod.end,
        delivery: formik.values.deliveryId,
        materials: Array.isArray(formik.values.material) ? formik.values.material : [],
        tripSeconds: formik.values.deliveryDurationSeconds,
        rentalPublicId: rental?.rentalPublicId
    });
    const deliveryTollOneWayCents = Number(deliveryEstimate?.tollOneWayCents) || 0;
    const selectedDeliveryOrigin = deliveryOrigins.find((origin) => origin.key === deliveryOriginKey) || deliveryOrigins[0] || null;
    const deliveryOriginOptions = deliveryOrigins.map((origin) => ({
        key: origin.key,
        label: origin.address ? `${origin.label} · ${origin.address}` : origin.label
    }));
    const deliveryMapsUrl = deliveryEstimate?.mapsUrl
        || buildDeliveryMapsUrl(selectedDeliveryOrigin?.address, String(formik.values.deliveryAddress || '').trim());
    const storedDeliveryEstimate = (!deliveryEstimate && Number(formik.values.deliveryDurationSeconds) > 0)
        ? { distanceMeters: Number(formik.values.deliveryDistanceMeters) || 0, durationSeconds: Number(formik.values.deliveryDurationSeconds) }
        : null;
    const rentalTotalReady = rentalTotalAmount > 0;

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldInvalid(name) ? <small className="p-error">{formik.errors[name]}</small> : <small className="p-error">&nbsp;</small>;
    };
    //----------------------------------------

  

    const selectedTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center" >
                    {(!IsNullOrEmpty(option.base64Picture)) ? (
                        <img className="smallPicture choiceService" key={option.id} alt={option.name} src={option.base64Picture || null} />

                    ) : (
                            <div className="no-picture-service no-picture-small choiceService"></div>
                    )}
                    <div>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;    
    };
    const optionTemplate = (option) => {
        return (
            <div className="flex align-items-center" >
                {(!IsNullOrEmpty(option.base64Picture)) ? (
                    <img className="smallPicture choiceService" key={option.id} alt={option.name} src={option.base64Picture || null} />

                ) : (
                        <div className="no-picture-service no-picture-small choiceService"></div>
                )}
                <div>{option.name}</div>
            </div>
        );
    };

    const formatClientOption = (client) => ({
        ...client,
        title: `${client.firstname} ${client.lastname} (${client.phone}) `
    });
    const [clientSearchTerm, setClientSearchTerm] = React.useState("");
    const [clientsCache, setClientsCache] = React.useState([]);
    const [clientsLoading, setClientsLoading] = React.useState(false);
    // Autocomplete Clients
    const onTagsChangeClients = (event, values) => {
        if (values) {
            formik.setFieldValue('firstname', values.firstname);
            formik.setFieldValue('lastname', values.lastname);
            formik.setFieldValue('phone', values.phone);
            formik.setFieldValue('email', values.email);
            formik.setFieldValue('address', values.address);
            if (!formik.values.deliveryAddress) {
                formik.setFieldValue('deliveryAddress', values.address);
            }
            formik.setFieldValue('clientType', values.clientType || "Private");
            formik.setFieldValue('companyName', values.companyName || "");
            formik.setFieldValue('siret', values.siret || "");
            if (values.birthdate)
                formik.setFieldValue('birthdate', new Date(values.birthdate));
            formik.setFieldValue('birthplace', values.birthplace);
            getClients(values.publicId).then(function (response) {
                if (response && response.lastRental) {
                    const lastDepositType = response.lastRental.depositType;
                    formik.setFieldValue('deposit', allowedDepositTypes.includes(lastDepositType) ? lastDepositType : defaultDepositType);
                }
            });
            //set id clientComment
            var comment = values.comment;
            if (comment) {
                document.getElementById("clientComment").innerHTML = "Notes : " + comment;
                document.getElementById("clientComment").style.display = "block";
            } else {
                document.getElementById("clientComment").innerHTML = "";
                document.getElementById("clientComment").style.display = "none";
            }
            setClientSearchTerm("");
            setOpenClients(false);
            setClientsLoading(false);
            setOptionscompleteClients([]);
        }
    }
    const [openClients, setOpenClients] = React.useState(false);
    const [optionscompleteClients, setOptionscompleteClients] = React.useState([]);
    const updateClientSearchTerm = (value = "") => {
        const term = value.trim();
        setClientSearchTerm(term);
        setOpenClients(term.length > 0);
    };
    const fetchClients = async () => {
        if (clientsCache.length) {
            return clientsCache;
        }
        const clients = await getClients();
        setClientsCache(clients);
        return clients;
    };

    React.useEffect(() => {
        let active = true;
        const hasSearch = clientSearchTerm.trim().length > 0;

        if (!hasSearch) {
            if (openClients && optionscompleteClients.length === 0) {
                setClientsLoading(true);
                fetchClients().then((clients) => {
                    if (!active) {
                        return;
                    }
                    setOptionscompleteClients(clients.map(formatClientOption));
                    setClientsLoading(false);
                });
            }
            return () => {
                active = false;
            };
        }

        const handler = setTimeout(() => {
            setClientsLoading(true);
            fetchClients().then((clients) => {
                if (!active) {
                    return;
                }
                const term = clientSearchTerm.toLowerCase();
                const filtered = clients.filter((client) => {
                    const haystack = `${client.firstname ?? ""} ${client.lastname ?? ""} ${client.phone ?? ""} ${client.email ?? ""} ${client.additionalContactsSearchText ?? ""}`.toLowerCase();
                    return haystack.includes(term);
                });
                setOptionscompleteClients(filtered.map(formatClientOption));
                if (filtered.length > 0) {
                    setOpenClients(true);
                }
                setClientsLoading(false);
            });
        }, 300);

        return () => {
            active = false;
            clearTimeout(handler);
        };
    }, [clientSearchTerm, openClients]);

    React.useEffect(() => {
        if (!openClients && clientSearchTerm.length === 0) {
            setOptionscompleteClients([]);
        }
        if (preselectMaterial) {
            GetToolOptions(preselectMaterial.publicId)
        }
            if (rental) {
                setDepositAmount(rental.deposit / 100)
                GetMaterialsOptions(rental.materialList || (rental.toolPublicId ? [rental.toolPublicId] : []))



                var opts = [];
                if (rental.optionsList) {
                    const optionIds = [];
                    rental.optionsList.map(item => {
                        const optionId = item.id ?? item.Id;
                        opts.push({
                            Id: optionId,
                            Name: item.name ?? item.Name,
                            Details: item.details ?? item.Details,
                            PriceCents: item.priceCents ?? item.PriceCents,
                            MerchandisePriceTiers: item.merchandisePriceTiers ?? item.MerchandisePriceTiers ?? [],
                            IsActivated: item.isActivated ?? item.IsActivated
                        });
                        optionIds.push(optionId);
                    });
                    setOptionQuantities(buildOptionQuantities(optionIds));
                    setSelectedOptions(opts.filter((option, index, self) => self.findIndex((candidate) => String(getOptionId(candidate)) === String(getOptionId(option))) === index))
                }

            }
    }, [openClients, clientSearchTerm]);


    const formatToolOption = (item) => ({
        Id: item.id ?? item.Id,
        Name: item.name ?? item.Name,
        Details: item.details ?? item.Details,
        PriceCents: item.priceCents ?? item.PriceCents,
        MerchandisePriceTiers: item.merchandisePriceTiers ?? item.MerchandisePriceTiers ?? [],
        IsActivated: item.isActivated ?? item.IsActivated ?? true
    });

    const sortToolOptions = (options) => {
        return [...options].sort((a, b) => (a.Name ?? "").localeCompare(b.Name ?? "", "fr-FR", { sensitivity: "base" }));
    };

    const GetToolOptions = async (publicToolId) => {
        if (!publicToolId) {
            setTooloptions([]);
            return;
        }

        const response = await getToolOptions(publicToolId);
        setTooloptions(sortToolOptions((response || []).map(formatToolOption)));
    };


    const GetMaterialsOptions = async (materials = selectedMaterials) => {
        const materialIds = Array.from(new Set((materials || []).filter(Boolean)));

        if (materialIds.length === 0) {
            setTooloptions([]);
            return;
        }

        const responses = await Promise.all(materialIds.map((materialId) => getToolOptions(materialId)));
        const uniqueOptions = new Map();

        responses.flatMap((response) => response || []).forEach((item) => {
            const option = formatToolOption(item);
            const optionId = getOptionId(option);
            if (optionId && !uniqueOptions.has(String(optionId))) {
                uniqueOptions.set(String(optionId), option);
            }
        });

        setTooloptions(sortToolOptions(Array.from(uniqueOptions.values())));
    };

    useEffect(() => {
        if (localDraftOptionIds.length && tooloptions && tooloptions.length) {
            const optionQuantitiesFromDraft = buildOptionQuantities(localDraftOptionIds);
            const selected = tooloptions.filter((option) => localDraftOptionIds.map(String).includes(String(getOptionId(option))));
            if (selected.length) {
                setSelectedOptions(selected.filter((option, index, self) => self.findIndex((candidate) => String(getOptionId(candidate)) === String(getOptionId(option))) === index));
                setOptionQuantities(optionQuantitiesFromDraft);
            }
        }
    }, [localDraftOptionIds, tooloptions]);

    const buildLocalDraftLabel = (values) => {
        const nameParts = [values.firstname, values.lastname].filter(Boolean);
        if (nameParts.length) {
            return nameParts.join(" ");
        }
        return "Brouillon local";
    };

    const saveLocalDraft = async ({ notifyUser = false } = {}) => {
        if (draftSaveInFlight.current) {
            return;
        }
        draftSaveInFlight.current = true;
        try {
            const draftId = localDraftId || null;
            const draftIdAtSaveStart = draftId;
            const urlDraftIdAtSaveStart = new URL(window.location.href).searchParams.get('draftId');
            const materialValues = getExpandedMaterialsFromSelection(selectedMaterials, materialQuantities);
            const draftValues = {
                ...formik.values,
                material: materialValues,
                dates: Array.isArray(formik.values.dates)
                    ? formik.values.dates.map((date) => (date ? new Date(date).toISOString() : null))
                    : formik.values.dates,
                birthdate: formik.values.birthdate ? new Date(formik.values.birthdate).toISOString() : null
            };

            const payload = {
                values: draftValues,
                selectedOptionIds: getExpandedOptionIdsFromSelection(selectedOptions || [], optionQuantities),
                availableDeposit,
                availableAdvancePayment,
                advancePaymentCollectionMode,
                signatureRequired
            };
            const savedDraft = await saveRentalDraft({
                publicId: draftId,
                json: JSON.stringify(payload),
                displayName: buildLocalDraftLabel(draftValues),
                source: "website"
            });

            const nextDraftId = savedDraft?.publicId || draftId;
            const currentUrlDraftId = new URL(window.location.href).searchParams.get('draftId');
            const draftContextChanged = currentUrlDraftId !== urlDraftIdAtSaveStart
                || localDraftIdRef.current !== draftIdAtSaveStart;

            if (draftContextChanged) {
                window.dispatchEvent(new Event("rental-drafts-updated"));
                return;
            }

            setLocalDraftId(nextDraftId);
            localDraftIdRef.current = nextDraftId;
            setLocalDraftMeta((previousMeta) => ({
                createdAt: savedDraft?.createdAtUtc ?? previousMeta.createdAt,
                updatedAt: savedDraft?.updatedAtUtc ?? previousMeta.updatedAt
            }));
            if (nextDraftId && !rental) {
                const url = new URL(window.location.href);
                const existingDraftId = url.searchParams.get('draftId');
                if (!existingDraftId) {
                    url.searchParams.set('draftId', nextDraftId);
                    window.history.replaceState({}, '', url.toString());
                }
            }
            window.dispatchEvent(new Event("rental-drafts-updated"));
            if (notifyUser) {
                send("success", "Le brouillon local a bien été sauvegardé.");
                notify();
            }
        } finally {
            draftSaveInFlight.current = false;
        }
    };

    const handleAutoSaveDraft = () => {
        if (Date.now() < (window.__lokappChangingDraftUntil || 0)) {
            return;
        }
        if (rental || isSaving || hydratingDraftRef.current) {
            return;
        }
        saveLocalDraft();
    };

    const deleteLocalDraft = async () => {
        if (!localDraftId) {
            return;
        }
        await deleteRentalDraft(localDraftId);
        setLocalDraftId(null);
        localDraftIdRef.current = null;
        setLocalDraftMeta({ createdAt: null, updatedAt: null });
        window.dispatchEvent(new Event("rental-drafts-updated"));
        send("success", "Le brouillon local a bien été supprimé.");
        notify();
        navigate("/ajouter");
    };




    React.useEffect(() => {
        let active = true;

        if (!loadingTools) {
            return undefined;
        }

        (async () => {
            if (active) {
                let tools = await getTools();
                if (tools.length === 0) {
                    send("warning", "Veuillez ajouter vos outils avant d'enregistrer une location !")
                    notify();
                }
                else {
                    let formattedTools = formatToolsForSelection(tools);

                    setOptionscompleteTools([...formattedTools]);

                    if (rental) {

                        // deposit values
                        if (rental.materialList) {
                            var deposit = 0;
                            rental.materialList.map(mat => {
                                var toolA = formattedTools.find(x => x.value === mat);
                                if (toolA) {
                                    deposit += toolA.deposit;
                                }
                            });
                            setDepositAmount(deposit / 100);
                            setSelectedMaterials(Array.from(new Set(rental.materialList)));
                            setMaterialQuantities(buildMaterialQuantities(rental.materialList));

                        }
                    }
                }

            }
        })();

        return () => {
            active = false;
        };
    }, [loadingTools]);

    const deleteLocation = (event) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Êtes-vous sûr de vouloir supprimer cette location ?',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Oui',
            rejectLabel: 'Non',
            accept: () => { accept(); },
            reject
        });
    };
    const accept = () => {
        var r = updateRental(rental.rentalPublicId, 'Cancelled');
        r.then(function (response) {
            
            send("success", "Le location a bien été supprimée !")
            window.location.href = `/${rental.rentalPublicId}`;

            
        })
    };
    const reject = () => {
    };

    const optionsTemplate = (option) => {
        return (
            <div className={classNames("rental-form-option-item", { "rental-form-option-item--unavailable": option.unavailable })}>
                <div>{option.Name} ({option.PriceCents/100}€)</div>
                {option.unavailable && <small>Option préselectionnée indisponible</small>}
            </div>
        );
    };

    
    const materialTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <img alt={option.name} src={option.base64Picture} className={`mr-2 flag`} style={{ width: '18px' }} />
                &nbsp;<div>{option.name}</div>
            </div>
        );
    };

    const panelFooterTemplate = () => {
        const length = selectedMaterials ? selectedMaterials.length : 0;

        return (
            <div className="py-2 px-3">
                <p><b>{length}</b> équipement{length > 1 ? 's' : ''} sélectionné{length > 1 ? 's' : ''}.</p>
                
            </div>
        );
    };



    const pageTitle = (rental) ? "Modifier une location" : "Ajouter une location";
    const pageSubtitle = (rental)
        ? "Mettez à jour les informations de location, le locataire, les paiements et la caution."
        : "Préparez une nouvelle location avec le matériel, le locataire, les dates et les conditions de paiement.";
    const toolOptionsForSelection = mergeAvailableAndSelectedOptions(tooloptions, selectedOptions);
    const advancePaymentFeeComparisons = availableAdvancePayment === "1" ? getAdvancePaymentFeeComparisons() : [];
    const bestAdvancePaymentFeeComparison = advancePaymentFeeComparisons[0];

    const panelHeader = (icon, title, subtitle) => (
        <div className="rental-form-panel-title">
            <i className={`pi ${icon}`} aria-hidden="true"></i>
            <span>
                <b>{title}</b>
                <small>{subtitle}</small>
            </span>
        </div>
    );

    return (
        <div className="rental-form-page">
            <ConfirmPopup />

            <div className="rental-form-header">
                <div>
                    <p className="rental-form-kicker">Location</p>
                    <h1>{pageTitle}</h1>
                    <p>{pageSubtitle}</p>
                </div>
                <div className="rental-form-header-card">
                    <span>{rental ? "Mode" : "Brouillon"}</span>
                    <b>{rental ? "Modification" : (localDraftId ? "Auto-enregistré" : "Nouveau")}</b>
                </div>
            </div>

            <Form
                className="rental-form"
                id="thumbnail-form"
                onSubmit={formik.handleSubmit}
                onBlur={handleAutoSaveDraft}
                method="post"
            >

                {localDraftId ? (
                    <div className="rental-form-draft">
                        <i className="pi pi-save" aria-hidden="true"></i>
                        <p><b>Brouillon enregistré le :</b> {formatDraftDate(localDraftMeta.createdAt)}</p>
                        <p><b>Dernière modification :</b> {formatDraftDate(localDraftMeta.updatedAt)}</p>
                    </div>
                ) : null}

                <Panel className="rental-form-panel rental-form-panel-location" header={panelHeader("pi-calendar", "Location", "Matériel, service et période de réservation.")}>
                    <div className="rental-form-location-selects">

                        <MultiSelect loading={loadingTools}
                            itemTemplate={materialTemplate} panelFooterTemplate={panelFooterTemplate} 
                            onShow={() => {
                                setOpenTools(true);
                                
                            }}
                            display='chip'
                            onHide={() => {
                                setOpenTools(false);
                                GetMaterialsOptions()
                            }}
                            id="multiMaterialsId"
                            open={openTools}
                            className={classNames("rental-form-material-select", { 'p-invalid': isFormFieldInvalid('material') })}

                            value={selectedMaterials || []} onChange={(e) => onTagsChangeTools(e.value)} options={optionscompleteTools} optionLabel="name"
                            filter filterDelay={100} placeholder="Sélectionnez votre matériel" maxSelectedLabels={10} />

                        <>
                            <Button
                                type="button"
                                label={`Quantités (${getTotalSelectedMaterials(selectedMaterials, materialQuantities)})`}
                                icon="pi pi-sliders-h"
                                text
                                size="small"
                                className="mt-0"
                                disabled={!selectedMaterials || selectedMaterials.length === 0}
                                onClick={() => setShowQuantityModal(true)}
                            />

                            <Dialog
                                header="Quantité par article"
                                visible={showQuantityModal}
                                modal
                                dismissableMask
                                closeOnEscape
                                className="rental-form-dialog"
                                style={{ width: '34rem', maxWidth: '95vw' }}
                                onHide={() => setShowQuantityModal(false)}
                                footer={
                                    <div className="rental-form-dialog-footer">
                                        <Button type="button" label="Fermer" icon="pi pi-check" onClick={() => setShowQuantityModal(false)} />
                                    </div>
                                }
                            >
                                <div className="rental-form-dialog-body">
                                    <p className="rental-form-dialog-intro">
                                        Ajustez la quantité souhaitée pour chaque article sélectionné.
                                    </p>
                                    {(selectedMaterials || []).map((materialId) => {
                                            const tool = optionscompleteTools.find((item) => item.value === materialId);
                                            const hasQuantityError = !!materialQuantityErrors[materialId];
                                            return (
                                                <div key={materialId} className="rental-form-dialog-item">
                                                    <label htmlFor={`material-qty-${materialId}`}>{tool?.name || materialId}</label>
                                                    <div className="rental-form-dialog-quantity">
                                                        <InputText
                                                            id={`material-qty-${materialId}`}
                                                            type="number"
                                                            min={1}
                                                            max={999}
                                                            maxLength={3}
                                                            value={materialQuantities[materialId] ?? 1}
                                                            onChange={(e) => onMaterialQuantityChange(materialId, e.target.value)}
                                                            className={classNames("rental-form-dialog-quantity-input", { 'p-invalid': hasQuantityError })}
                                                        />
                                                        <span>exemplaire(s)</span>
                                                    </div>
                                                    {hasQuantityError && (
                                                        <small className="p-error">Veuillez saisir une quantité entière entre 1 et 999.</small>
                                                    )}
                                                </div>
                                            );
                                    })}
                                </div>
                            </Dialog>
                        </>

                        <div className="rental-form-service-field">
                            <Dropdown valueTemplate={selectedTemplate} itemTemplate={optionTemplate} data-cy="serviceDropD" id="serviceId" name="serviceId" value={formik.values.serviceId}
                            onChange={(e) => {
                                const nextServiceId = e.target.value;
                                const wasBricolib = isBricolibServiceByValue(formik.values.serviceId);
                                const isNowBricolib = isBricolibServiceByValue(nextServiceId);

                                formik.setFieldValue('serviceId', nextServiceId);

                                if (!wasBricolib && isNowBricolib) {
                                    setShowBricolibModal(true);
                                }
                                if (wasBricolib && !isNowBricolib) {
                                    setShowBricolibModal(false);
                                }
                            }}
                            className={classNames("rental-form-service-select", { 'p-invalid': isFormFieldInvalid('serviceId') })}
                            options={formattedServices} optionLabel="name" placeholder="S&eacute;lectionnez un service"
                            filter />

                            {isBricolibService && (
                                <Button
                                    type="button"
                                    icon="pi pi-file-pdf"
                                    text
                                    rounded
                                    aria-label="Importer un contrat Bricolib"
                                    tooltip="Importer le PDF Bricolib"
                                    onClick={() => setShowBricolibModal(true)}
                                />
                            )}
                        </div>

                        <Dialog
                            header="Contrat Bricolib"
                            visible={showBricolibModal && isBricolibService}
                            modal
                            dismissableMask
                            closeOnEscape
                            className="rental-form-dialog"
                            style={{ width: '32rem', maxWidth: '95vw' }}
                            breakpoints={{ '960px': '85vw', '640px': '95vw' }}
                            onHide={() => setShowBricolibModal(false)}
                        >
                            <div className="rental-form-dialog-body">
                                <p className="rental-form-dialog-intro">
                                    Importez le contrat PDF Bricolib pour pr&eacute;remplir automatiquement le locataire (nom, pr&eacute;nom, adresse, t&eacute;l&eacute;phone, email).
                                </p>
                                <label className="rental-form-dialog-upload">
                                    <i className="pi pi-file-pdf"></i>
                                    <span>Contrat PDF Bricolib</span>
                                    <input
                                        type="file"
                                        accept="application/pdf,.pdf"
                                        onChange={onBricolibPdfUpload}
                                        disabled={isExtractingBricolibPdf}
                                    />
                                </label>
                                {isExtractingBricolibPdf && <small>Analyse du PDF...</small>}
                            </div>
                        </Dialog>

                    </div>
 
                    <div className="rental-form-period-row">

                        <span className="p-float-label">
                            <Calendar id="dates" name="dates" value={formik.values.dates} dateFormat="yy-mm-dd" selectionMode="range" data-cy="calendar"
                                onChange={(e) => {
                                    formik.setFieldValue('dates', e.target.value);
                                    resetActualPrice();
                                    selectedDates(e.target.value)
                                }}
                            className={classNames({ 'p-invalid': isFormFieldInvalid('dates') })}
                             />
                            <label htmlFor="dates">Date</label>
                        </span>
                        <span className="p-float-label">
                            <InputText id="rentalHour" name="rentalHour" value={formik.values.rentalHour} data-cy="rentalHour"
                                onChange={(e) => {
                                    
                                    formik.setFieldValue('rentalHour', e.target.value);
                                    resetActualPrice();

                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('rentalHour') })}
                            />
                            <label htmlFor="rentalHour">Début</label>
                        </span>
                        <span className="p-float-label">
                            <InputText id="rentalHourEnd" name="rentalHourEnd" value={formik.values.rentalHourEnd} data-cy="rentalHourEnd"
                                onChange={(e) => {

                                    formik.setFieldValue('rentalHourEnd', e.target.value);
                                    resetActualPrice();

                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('rentalHourEnd') })}
                            />
                            <label htmlFor="rentalHourEnd">Fin</label>
                        </span>
                    </div >
                </Panel>
                <Panel className="rental-form-panel rental-form-panel-client" header={panelHeader("pi-user", "Locataire", "Identité, coordonnées et adresse du client.")}>
                    <div className="contentForm">
                        <span className="p-float-label" id="clientComment" style={{ display: "none" }}></span>
                    </div >
                    <div className="contentForm">
                        <div className="flex align-items-center">
                            <RadioButton
                                inputId="client-type-private"
                                name="clientType"
                                value="Private"
                                onChange={(e) => {
                                    formik.setFieldValue('clientType', e.value);
                                    formik.setFieldValue('companyName', '');
                                    formik.setFieldValue('siret', '');
                                }}
                                checked={formik.values.clientType === 'Private'}
                            />
                            <label htmlFor="client-type-private" className="ml-2">Particulier</label>
                        </div>
                        <div className="flex align-items-center">
                            <RadioButton
                                inputId="client-type-professional"
                                name="clientType"
                                value="Professional"
                                onChange={(e) => {
                                    formik.setFieldValue('clientType', e.value);
                                    formik.setFieldValue('birthdate', null);
                                    formik.setFieldValue('birthplace', '');
                                }}
                                checked={formik.values.clientType === 'Professional'}
                            />
                            <label htmlFor="client-type-professional" className="ml-2">Professionnel</label>
                        </div>
                    </div>
                    {formik.values.clientType === "Professional" && (
                        <div className="contentForm">
                            <span className="p-float-label">
                                <InputText id="companyName" name="companyName" value={formik.values.companyName}
                                    onChange={(e) => formik.setFieldValue('companyName', e.target.value)}
                                    className={classNames({ 'p-invalid': isFormFieldInvalid('companyName') })}
                                />
                                <label htmlFor="companyName">Nom de la soci&eacute;t&eacute;</label>
                            </span>
                            <span className="p-float-label">
                                <InputText id="siret" name="siret" value={formik.values.siret}
                                    onChange={(e) => formik.setFieldValue('siret', e.target.value)}
                                    className={classNames({ 'p-invalid': isFormFieldInvalid('siret') })}
                                />
                                <label htmlFor="siret">SIRET (optionnel)</label>
                            </span>
                        </div>
                    )}
                    <div className="contentForm">
                        
                        <span className="p-float-label">
                            <InputText id="firstname" name="firstname" value={formik.values.firstname}
                                data-cy="firstname"
                            onChange={(e) => {
                                const value = e.target.value;
                                formik.setFieldValue('firstname', value);
                                updateClientSearchTerm(value);
                            }}
                            className={classNames({ 'p-invalid': isFormFieldInvalid('firstname') })}
                                />
                            <label htmlFor="firstname">Pr&eacute;nom</label>
                        </span>
                        <span className="p-float-label">
                            <InputText id="lastname" name="lastname" value={formik.values.lastname} data-cy="lastname"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    formik.setFieldValue('lastname', value);
                                    updateClientSearchTerm(value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('lastname') })}
                                    />
                            <label htmlFor="lastname">Nom</label>
                        </span>
                        {formik.values.clientType !== "Professional" && (
                            <>
                                <span className="p-float-label">
                                    <Calendar id="birthdate" name="birthdate" value={formik.values.birthdate} data-cy="birthdate"
                                        dateFormat="dd/mm/yy"
                                        onChange={(e) => {
                                            formik.setFieldValue('birthdate', e.target.value);
                                        }}
                                        className={classNames({ 'p-invalid': isFormFieldInvalid('birthdate') })}
                                    />
                                    <label htmlFor="birthdate">N&eacute;(e) le</label>
                                </span>
                                <span className="p-float-label">
                                    <InputText id="birthplace" name="birthplace" value={formik.values.birthplace} data-cy="birthplace"
                                        onChange={(e) => {
                                            formik.setFieldValue('birthplace', e.target.value);
                                        }}
                                        className={classNames({ 'p-invalid': isFormFieldInvalid('birthplace') })}
                                    />
                                    <label htmlFor="birthplace">Lieu de naissance</label>
                                </span>
                            </>
                        )}
                        </div> 

                    <div className="contentForm">
                        <span className="p-float-label">
                            <InputText type="tel" id="phone" name="phone" value={formik.values.phone} data-cy="phone"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    formik.setFieldValue('phone', value);
                                    updateClientSearchTerm(value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('phone') })}
                                />
                            <label htmlFor="phone">T&eacute;l&eacute;phone</label>
                            {isFormFieldInvalid('phone') && <small className="p-error">{formik.errors.phone}</small>}
                        </span>
                        <span className="p-float-label">
                            <InputText type="email" id="email" name="email" value={formik.values.email} data-cy="email"
                            onChange={(e) => {
                                formik.setFieldValue('email', e.target.value);
                            }}
                            className={classNames({ 'p-invalid': isFormFieldInvalid('email') })}
                            />
                            <label htmlFor="email">Email</label>
                        </span>
                        <span className="p-float-label">
                            <InputText id="address" name="address" value={formik.values.address} data-cy="address"
                                onChange={(e) => {
                                    formik.setFieldValue('address', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('address') })}
                            />
                            <label htmlFor="address">Adresse</label>

                        </span>
                        {getFormErrorMessage('address')}
                    </div >
                    <section className="rental-contacts">
                        <div className="rental-contacts-header">
                            <div>
                                <strong>Contacts additionnels</strong>
                                <small>Facultatifs — livraison, retrait ou suivi.</small>
                            </div>
                            <Button type="button" label="Ajouter" icon="pi pi-plus" outlined onClick={addRentalContact} />
                        </div>
                        {Array.isArray(formik.values.rentalContacts) && formik.values.rentalContacts.length > 0 && (
                            <div className="rental-contacts-list">
                            {formik.values.rentalContacts.map((contact, index) => (
                                <div key={index} className="rental-contact-card">
                                <span className="p-float-label">
                                    <InputText id={`rental-contact-name-${index}`} value={contact.name || ''} onChange={(e) => updateRentalContact(index, 'name', e.target.value)} />
                                    <label htmlFor={`rental-contact-name-${index}`}>Nom *</label>
                                </span>
                                <span className="p-float-label">
                                    <InputText id={`rental-contact-role-${index}`} value={contact.role || ''} onChange={(e) => updateRentalContact(index, 'role', e.target.value)} />
                                    <label htmlFor={`rental-contact-role-${index}`}>Rôle (optionnel)</label>
                                </span>
                                <span className="p-float-label">
                                    <InputText type="tel" id={`rental-contact-phone-${index}`} value={contact.phone || ''} onChange={(e) => updateRentalContact(index, 'phone', e.target.value)} />
                                    <label htmlFor={`rental-contact-phone-${index}`}>Téléphone</label>
                                </span>
                                <span className="p-float-label">
                                    <InputText type="email" id={`rental-contact-email-${index}`} value={contact.email || ''} onChange={(e) => updateRentalContact(index, 'email', e.target.value)} />
                                    <label htmlFor={`rental-contact-email-${index}`}>Email</label>
                                </span>
                                    <Button type="button" className="rental-contact-delete" icon="pi pi-trash" severity="danger" text rounded aria-label="Supprimer ce contact" onClick={() => removeRentalContact(index)} />
                                </div>
                            ))}
                            </div>
                        )}
                        {getFormErrorMessage('rentalContacts')}
                    </section>
                    {openClients && (
                        <div className="contentForm">
                            <div
                                className="p-component p-shadow-2"
                                style={{
                                    width: "100%",
                                    borderRadius: "8px",
                                    border: "2px solid #cbd5e1",
                                    background: "#fff",
                                    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.18)",
                                    marginTop: "0.5rem",
                                    maxHeight: "240px",
                                    overflowY: "auto",
                                    position: "relative",
                                    zIndex: 5
                                }}
                            >
                                {clientsLoading && (
                                    <div style={{ padding: "0.75rem" }}>Recherche en cours...</div>
                                )}
                                {!clientsLoading && optionscompleteClients.map((client) => (
                                    <button
                                        type="button"
                                        key={client.publicId}
                                        onClick={() => onTagsChangeClients(null, client)}
                                        style={{
                                            width: "100%",
                                            textAlign: "left",
                                            padding: "0.75rem 1rem",
                                            border: "none",
                                            borderBottom: "1px solid #e2e8f0",
                                            background: "transparent",
                                            cursor: "pointer",
                                            fontWeight: 600
                                        }}
                                    >
                                        <div>{client.firstname} {client.lastname} · {client.phone}</div>
                                        {client.comment && (
                                            <div style={{ marginTop: "0.25rem", fontWeight: 400, color: "#475569" }}>
                                                Remarque : {client.comment}
                                            </div>
                                        )}
                                    </button>
                                ))}
                                {!clientsLoading && optionscompleteClients.length === 0 && (
                                    <div style={{ padding: "0.75rem" }}>Aucun client trouv&eacute;.</div>
                                )}
                            </div>
                        </div>
                    )}
                </Panel>

                
                    
                <Panel className="rental-form-panel rental-form-panel-options" header={panelHeader("pi-sliders-h", "Autres", "Livraison, options, prix personnalisé et commentaire.")}>
                    <div className="rental-form-options-grid rental-form-delivery-grid">
                        <span className="p-float-label">
                            <Dropdown data-cy="deliveryDropD" id="deliveryId" name="deliveryId" value={formik.values.deliveryId}
                                onChange={(e) => {
                                    formik.setFieldValue('deliveryId', e.target.value);
                                    if (hasDeliveryOrPickup(e.target.value) && !formik.values.deliveryAddress) {
                                        formik.setFieldValue('deliveryAddress', formik.values.address || '');
                                    }
                                    if (!hasDeliveryOrPickup(e.target.value)) {
                                        formik.setFieldValue('deliveryFees', '');
                                    }
                                }}
                                className={classNames('rental-form-delivery-select', { 'p-invalid': isFormFieldInvalid('deliveryId') })}
                                options={formattedDeliveries} optionLabel="name" placeholder="S&eacute;lectionnez un mode de livraison"
                                />
                            <label htmlFor="deliveryId">Mode de livraison</label>
                        </span>
                        {hasDeliveryOrPickup(formik.values.deliveryId) && (
                            <div className="rental-form-delivery-fees">
                                <span className="p-float-label">
                                    <InputText id="deliveryFees" name="deliveryFees" value={formik.values.deliveryFees}
                                        keyfilter="money"
                                        maxLength={7}
                                        onChange={(e) => {
                                            formik.setFieldValue('deliveryFees', e.target.value);
                                        }}
                                        onFocus={getActualPrice}
                                        className={classNames({ 'p-invalid': isFormFieldInvalid('deliveryFees') })}
                                    />
                                    <label htmlFor="deliveryFees">Frais</label>
                                </span>
                                {getFormErrorMessage('deliveryFees')}
                            </div>
                        )}
                        {hasDeliveryOrPickup(formik.values.deliveryId) && (
                            <div className="rental-form-delivery-address" data-cy="deliveryAddressField">
                                <span className="p-float-label">
                                    <AutoComplete inputId="deliveryAddress" name="deliveryAddress" value={formik.values.deliveryAddress}
                                        suggestions={deliveryAddressSuggestions}
                                        completeMethod={searchDeliveryAddress}
                                        minLength={3}
                                        delay={350}
                                        onChange={(e) => setDeliveryAddressValue(e.value)}
                                        className={classNames('rental-form-delivery-autocomplete', { 'p-invalid': isFormFieldInvalid('deliveryAddress') })}
                                        inputClassName={classNames({ 'p-invalid': isFormFieldInvalid('deliveryAddress') })}
                                        pt={{ input: { root: { 'data-cy': 'deliveryAddress' } } }}
                                    />
                                    <label htmlFor="deliveryAddress">Adresse de livraison/reprise</label>
                                </span>
                                <Button
                                    type="button"
                                    icon="pi pi-copy"
                                    text
                                    rounded
                                    aria-label="Utiliser l'adresse du locataire"
                                    tooltip="Utiliser l'adresse du locataire"
                                    onClick={() => setDeliveryAddressValue(formik.values.address || '')}
                                />
                                {getFormErrorMessage('deliveryAddress')}
                                {deliveryAutocompleteError && (
                                    <small className="rental-form-delivery-autocomplete-note">
                                        <i className="pi pi-info-circle" aria-hidden="true"></i>
                                        {deliveryAutocompleteError} La saisie manuelle reste possible.
                                    </small>
                                )}
                            </div>
                        )}
                        <DeliveryVehicleNotice check={deliveryVehicleCheck} currentRentalPublicId={rental?.rentalPublicId} />
                        {hasDeliveryOrPickup(formik.values.deliveryId) && (
                            <div className="rental-form-delivery-estimate" data-cy="deliveryEstimate">
                                <div className="rental-form-delivery-estimate__controls">
                                    {deliveryOrigins.length > 1 && (
                                        <span className="p-float-label">
                                            <Dropdown inputId="deliveryOrigin" value={deliveryOriginKey} options={deliveryOriginOptions}
                                                optionLabel="label" optionValue="key"
                                                className="rental-form-delivery-origin"
                                                onChange={(e) => {
                                                    deliveryOriginTouchedRef.current = true;
                                                    setDeliveryOriginKey(e.value);
                                                    setDeliveryEstimate(null);
                                                    setDeliveryEstimateError(null);
                                                }}
                                            />
                                            <label htmlFor="deliveryOrigin">Point de départ</label>
                                        </span>
                                    )}
                                    <Button
                                        type="button"
                                        icon="pi pi-car"
                                        label="Estimer les frais"
                                        size="small"
                                        outlined
                                        loading={deliveryEstimateLoading}
                                        disabled={deliveryEstimateLoading || !String(formik.values.deliveryAddress || '').trim()}
                                        onClick={runDeliveryEstimate}
                                    />
                                    {deliveryMapsUrl && (
                                        <a className="rental-form-delivery-estimate__link" href={deliveryMapsUrl} target="_blank" rel="noreferrer">
                                            <i className="pi pi-map" aria-hidden="true"></i>
                                            Voir l'itinéraire
                                        </a>
                                    )}
                                </div>
                                {!deliveryEstimate && (
                                    <small className="rental-form-delivery-estimate__hint">
                                        {deliveryDepartureDate
                                            ? `Trafic prévu le ${formatDepartureLabel(deliveryDepartureDate)} (${formik.values.deliveryId === "PickupOnly" ? "fin" : "début"} de location).`
                                            : "Renseignez les dates et l'heure pour un temps de trajet avec le trafic prévu ; sinon le calcul se fait sans trafic."}
                                    </small>
                                )}
                                {deliveryEstimateError && <small className="p-error">{deliveryEstimateError}</small>}
                                {deliveryEstimate && (
                                    <div className="rental-form-delivery-estimate__result" aria-live="polite">
                                        <div className="rental-form-delivery-estimate__summary">
                                            <i className="pi pi-clock" aria-hidden="true"></i>
                                            <span>
                                                <b>{formatTripDistance(deliveryEstimate.distanceMeters)} · {formatTripDuration(deliveryEstimate.durationSeconds)} de trajet simple</b>
                                                <small>
                                                    {deliveryEstimate.trafficAware
                                                        ? `Trafic prévu le ${formatDepartureLabel(deliveryEstimate.departureTime)}${deliveryEstimate.staticDurationSeconds ? ` (${formatTripDuration(deliveryEstimate.staticDurationSeconds)} sans trafic)` : ""}`
                                                        : "Sans trafic"}
                                                    {" · "}{deliveryTollOneWayCents > 0
                                                        ? `péages ${formatEuroCents(deliveryTollOneWayCents)} par trajet, comptés aller-retour à chaque passage`
                                                        : "aucun péage détecté"}
                                                </small>
                                                {deliveryEstimate.fuelPriceCents > 0 && (
                                                    <small>
                                                        Carburant : {deliveryEstimate.fuelLabel || "Gazole"} {formatLiterPrice(deliveryEstimate.fuelPriceCents)}
                                                        {deliveryEstimate.fuelPriceScopeLabel ? ` (${deliveryEstimate.fuelPriceScopeLabel}, ${deliveryEstimate.fuelPriceStationCount} stations)` : ""}
                                                        {deliveryProposals[0]?.fuelCostCentsPerLeg > 0 ? ` · environ ${formatEuroCents(deliveryProposals[0].fuelCostCentsPerLeg)} de carburant par passage à ${Number(deliveryEstimate.fuelConsumptionLitersPer100Km || 0).toLocaleString("fr-FR")} L/100 km` : ""}
                                                        {deliveryEstimate.fuelSurchargeEnabled
                                                            ? (deliveryEstimate.fuelReferencePriceCents > 0
                                                                ? ` · indexé sur ${formatLiterPrice(deliveryEstimate.fuelReferencePriceCents)} de référence`
                                                                : " · indexation sans effet : prix de référence non renseigné dans Paramètres")
                                                            : ""}
                                                    </small>
                                                )}
                                                <small>
                                                    {getDeliveryLegCount(formik.values.deliveryId)} passage{getDeliveryLegCount(formik.values.deliveryId) > 1 ? "s" : ""} facturé{getDeliveryLegCount(formik.values.deliveryId) > 1 ? "s" : ""}
                                                    {formik.values.deliveryId === "DeliveryWithPickupAndSetup" && deliveryEstimate.setupSupplementCents > 0 ? ` + ${formatEuroCents(deliveryEstimate.setupSupplementCents)} d'installation` : ""}
                                                    {deliveryEstimate.originLabel ? ` · départ ${deliveryEstimate.originLabel}` : ""}
                                                </small>
                                            </span>
                                        </div>
                                        {deliveryEstimateStale && (
                                            <small className="rental-form-delivery-estimate__warning">
                                                <i className="pi pi-exclamation-triangle" aria-hidden="true"></i>
                                                Dates ou heure modifiées depuis l'estimation : relancez « Estimer les frais » pour le trafic prévu.
                                            </small>
                                        )}
                                        <div className="rental-form-delivery-proposals" role="radiogroup" aria-label="Proposition de tarif">
                                            {deliveryProposals.map((proposal, index) => {
                                                const selected = proposal.mode === deliverySelectedMode;
                                                const totalCents = deliveryProposalTotals[index];
                                                const badge = proposal.recommended
                                                    ? (totalCents >= deliveryBestTotalCents ? "Le plus avantageux" : "Présélectionné")
                                                    : null;
                                                return (
                                                    <button
                                                        type="button"
                                                        key={proposal.mode}
                                                        role="radio"
                                                        aria-checked={selected}
                                                        data-cy={`deliveryProposal-${proposal.mode}`}
                                                        className={classNames("rental-form-delivery-proposal", { "rental-form-delivery-proposal--selected": selected })}
                                                        onClick={() => setDeliverySelectedMode(proposal.mode)}
                                                    >
                                                        <span className="rental-form-delivery-proposal__head">
                                                            <i className={selected ? "pi pi-check-circle" : "pi pi-circle"} aria-hidden="true"></i>
                                                            <b>{proposal.mode === "PerKilometer" ? "À la distance" : "Au temps de trajet"}</b>
                                                            {badge && <em>{badge}</em>}
                                                        </span>
                                                        <small>
                                                            {formatBillableUnits(proposal)} × {formatEuroCents(proposal.rateCents)} = {formatEuroCents(proposal.minimumApplied ? proposal.legPriceBeforeMinimumCents : proposal.legPriceCents)} par passage
                                                            {proposal.tollCentsPerLeg > 0 ? ` + ${formatEuroCents(proposal.tollCentsPerLeg)} de péages` : ""}
                                                            {proposal.fuelSurchargeCentsPerLeg ? ` ${formatSignedEuroCents(proposal.fuelSurchargeCentsPerLeg)} d'indexation carburant` : ""}
                                                        </small>
                                                        {proposal.minimumApplied && (
                                                            <small className="rental-form-delivery-proposal__note">
                                                                <i className="pi pi-info-circle" aria-hidden="true"></i>
                                                                Prix minimum appliqué : {formatEuroCents(proposal.legPriceCents)} par passage au lieu de {formatEuroCents(proposal.legPriceBeforeMinimumCents)}.
                                                            </small>
                                                        )}
                                                        <span className="rental-form-delivery-proposal__total">{formatEuroCents(totalCents)}</span>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                        <div className="rental-form-delivery-estimate__actions">
                                            <Button
                                                type="button"
                                                size="small"
                                                icon={deliveryEstimateApplied ? "pi pi-check-circle" : "pi pi-check"}
                                                label={deliveryEstimateApplied ? "Appliqué" : `Appliquer ${formatEuroCents(deliveryEstimateTotalCents)}`}
                                                disabled={deliveryEstimateApplied}
                                                onClick={applyDeliveryEstimate}
                                            />
                                        </div>
                                    </div>
                                )}
                                {storedDeliveryEstimate && (
                                    <small className="rental-form-delivery-estimate__stored">
                                        Estimation enregistrée : {formatTripDistance(storedDeliveryEstimate.distanceMeters)} · {formatTripDuration(storedDeliveryEstimate.durationSeconds)} de trajet simple.
                                    </small>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="rental-form-options-grid rental-form-options-grid--details">
                        {tooloptions && (tooloptions.length > 0) &&
                            (
                                <>
                                <div className="rental-form-option-picker">
                                    <span className="p-float-label">
                                        <MultiSelect itemTemplate={optionsTemplate} id="options2" value={selectedOptions}
                                            onChange={(e) => onOptionsChange(e.value)}
                                            options={toolOptionsForSelection} optionLabel="Name" dataKey="Id" display="chip"
                                            placeholder="Sélectionnez les options" maxSelectedLabels={3} />
                                        <label htmlFor="options2">Sélectionnez les options</label>
                                    </span>
                                    <Button
                                        type="button"
                                        label={`(${getTotalSelectedOptions(selectedOptions, optionQuantities)})`}
                                        icon="pi pi-sliders-h"
                                        text
                                        size="small"
                                        disabled={!selectedOptions || selectedOptions.length === 0}
                                        onClick={() => setShowOptionQuantityModal(true)}
                                    />
                                    <small className="rental-form-option-help">
                                        Les options classiques sont ajoutées au listing du matériel loué dans le contrat. Les options liées à une marchandise sont affichées séparément comme consommables, hors biens loués.
                                    </small>
                                </div>
                                <Dialog
                                    header="Quantité par option"
                                    visible={showOptionQuantityModal}
                                    modal
                                    dismissableMask
                                    closeOnEscape
                                    className="rental-form-dialog"
                                    style={{ width: '34rem', maxWidth: '95vw' }}
                                    onHide={() => setShowOptionQuantityModal(false)}
                                    footer={
                                        <div className="rental-form-dialog-footer">
                                            <Button type="button" label="Fermer" icon="pi pi-check" onClick={() => setShowOptionQuantityModal(false)} />
                                        </div>
                                    }
                                >
                                    <div className="rental-form-dialog-body">
                                        <p className="rental-form-dialog-intro">
                                            Ajustez la quantité souhaitée pour chaque option sélectionnée.
                                        </p>
                                        {(selectedOptions || []).map((option) => {
                                            const optionId = getOptionId(option);
                                            if (!optionId) {
                                                return null;
                                            }
                                            const hasQuantityError = !!optionQuantityErrors[optionId];
                                            const quantity = Number(optionQuantities[optionId]) || 1;
                                            const appliedTier = getApplicableMerchandiseTier(option, quantity);
                                            const appliedTierMinimum = appliedTier ? getMerchandiseTierMinimum(appliedTier) : null;
                                            const appliedTierPrice = appliedTier ? Number(appliedTier.unitPrice ?? appliedTier.UnitPrice) : null;
                                            return (
                                                <div key={optionId} className="rental-form-dialog-item">
                                                    <label htmlFor={`option-qty-${optionId}`}>{option?.Name || optionId}</label>
                                                    <div className="rental-form-dialog-quantity">
                                                        <InputText
                                                            id={`option-qty-${optionId}`}
                                                            type="number"
                                                            min={1}
                                                            max={999}
                                                            maxLength={3}
                                                            value={optionQuantities[optionId] ?? 1}
                                                            onChange={(e) => onOptionQuantityChange(optionId, e.target.value)}
                                                            className={classNames("rental-form-dialog-quantity-input", { 'p-invalid': hasQuantityError })}
                                                        />
                                                        <span>exemplaire(s)</span>
                                                    </div>
                                                    {hasQuantityError && (
                                                        <small className="p-error">Veuillez saisir une quantité entière entre 1 et 999.</small>
                                                    )}
                                                    <small className="rental-form-tier-notice">
                                                        {!appliedTier
                                                            ? `Prix standard appliqué : ${((option.PriceCents ?? option.priceCents ?? 0) / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })} / unité.`
                                                            : quantity >= appliedTierMinimum
                                                                ? `Palier appliqué dès ${appliedTierMinimum} unités : ${appliedTierPrice.toLocaleString("fr-FR", { style: "currency", currency: "EUR" })} / unité.`
                                                                : `Tarif du premier palier appliqué : ${appliedTierPrice.toLocaleString("fr-FR", { style: "currency", currency: "EUR" })} / unité.`}
                                                    </small>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </Dialog>
                                </>
                                )
                        }
                        
                        <span className="p-float-label">

                            <InputText id="options" name="options" value={formik.values.options} data-cy="option"
                                onChange={(e) => {
                                    formik.setFieldValue('options', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('options') })}
                            />
                            <label htmlFor="options">Autres options</label>
                        </span>

                        <span className="p-float-label rental-form-custom-price-field">
                            <InputText id="customPrice" name="customPrice" value={formik.values.customPrice} data-cy="customPrice"
                                keyfilter="money"
                                onChange={(e) => {
                                    formik.setFieldValue('customPrice', e.target.value);
                                }}
                                onFocus={getActualPrice}
                                onBlur={resetActualPrice}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('customPrice') })}
                            />
                            <label htmlFor="customPrice">Prix personalis&eacute;</label>
                            {(actualPrice) && (
                                <small className="rental-form-price-hint">au lieu de {actualPrice}€ frais inclus</small>
                            )}
                        </span>

                    </div >
                    <div className="rental-form-comment-row">
                        <span className="p-float-label">
                            <InputTextarea id="comment" name="comment" value={formik.values.comment} data-cy="comment"
                                onChange={(e) => {
                                    formik.setFieldValue('comment', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('comment') })}
                            />
                            <label htmlFor="comment">Commentaire</label>
                        </span>
                    </div >
                </Panel>
               

                <Panel className="rental-form-panel rental-form-panel-advance" header={panelHeader("pi-wallet", "Acompte", "Définissez si un acompte est requis avant la location.")}>

                    <div className="contentForm">
                        <div>Demander un acompte :&nbsp;</div >
                       
                        <div className="flex flex-wrap gap-3">
                            <div className="flex align-items-center choiceDepositRadio">
                                <RadioButton inputId="advance-payment-yes" name="availableAdvancePayment" value="1" onChange={(e) => {
                                    setAvailableAdvancePayment(e.value);
                                    fillAdvancePaymentAmountIfNeeded();
                                }} checked={availableAdvancePayment === '1'} />
                                <label htmlFor="advance-payment-yes" className="ml-2"> Oui</label>
                            </div>
                            <div className="flex align-items-center choiceDepositRadio">
                                <RadioButton inputId="advance-payment-no" name="availableAdvancePayment" value="0" onChange={(e) => {
                                    setAvailableAdvancePayment(e.value)
                                }} checked={availableAdvancePayment === '0' } />
                                <label htmlFor="advance-payment-no" className="ml-2"> Non</label>
                            </div>

                        </div>
                    </div>
                    {(availableAdvancePayment === "1" ) && (
                        <>
                            <div className="rental-form-advance-box">
                                <div className="rental-form-advance-row">
                                    <div className="rental-form-advance-field">
                                        <Tooltip target=".advance-payment-percent-tooltip" />
                                        <div className="rental-form-advance-label">
                                            <label htmlFor="advancePaymentAmountCentsNeeded">Montant de l'acompte</label>
                                            {advancePercentHint > 0 && (
                                                <i
                                                    className="pi pi-info-circle advance-payment-percent-tooltip"
                                                    data-pr-tooltip={`${advancePercentHint}% du montant de la location`}
                                                    data-pr-position="top"
                                                    aria-label={`${advancePercentHint}% du montant de la location`}
                                                ></i>
                                            )}
                                        </div>
                                        <div className="rental-form-advance-amount">
                                            <InputText id="advancePaymentAmountCentsNeeded" name="advancePaymentAmountCentsNeeded" value={formik.values.advancePaymentAmountCentsNeeded} data-cy="advancePaymentAmountCentsNeeded"
                                                keyfilter="money"
                                                onFocus={fillAdvancePaymentAmountIfNeeded}
                                                onChange={(e) => {
                                                    lastSuggestedAdvanceAmount.current = null;
                                                    formik.setFieldValue('advancePaymentAmountCentsNeeded', e.target.value);
                                                }}
                                                className={classNames({ 'p-invalid': isFormFieldInvalid('advancePaymentAmountCentsNeeded') })}
                                            />
                                            <span>€</span>
                                        </div>
                                    </div>
                                    <div className="rental-form-advance-mode-group">
                                        <span>Mode d'encaissement</span>
                                        <div className="rental-form-advance-modes">
                                            {getAdvancePaymentModeOptions().map((mode) => (
                                                <label
                                                    className={classNames("rental-form-advance-mode", { "rental-form-advance-mode--selected": advancePaymentCollectionMode === mode.value })}
                                                    htmlFor={`advance-payment-mode-${mode.value}`}
                                                    key={mode.value}
                                                >
                                                    <RadioButton
                                                        inputId={`advance-payment-mode-${mode.value}`}
                                                        name="advancePaymentCollectionMode"
                                                        value={mode.value}
                                                        onChange={(e) => {
                                                            setAdvancePaymentCollectionMode(e.value);
                                                            formik.setFieldValue('advancePaymentCollectionMode', e.value);
                                                        }}
                                                        checked={advancePaymentCollectionMode === mode.value}
                                                    />
                                                    <i className={mode.icon} aria-hidden="true"></i>
                                                    <span>
                                                        <b>{mode.label}</b>
                                                        <small>{mode.helper}</small>
                                                    </span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                            {bestAdvancePaymentFeeComparison && (
                                <div className="rental-payment-fee-comparison rental-payment-fee-comparison--form">
                                    <div className="rental-payment-fee-comparison__recommendation">
                                        <i className="pi pi-chart-line" aria-hidden="true"></i>
                                        <span>
                                            <small>Encaissement le plus avantageux</small>
                                            <b>{bestAdvancePaymentFeeComparison.name} · frais estimés {formatAmount(bestAdvancePaymentFeeComparison.feesCents)}</b>
                                            <small>Mode utilisé : {getAdvancePaymentModeLabel(bestAdvancePaymentFeeComparison.mode)}</small>
                                        </span>
                                        {advancePaymentCollectionMode !== bestAdvancePaymentFeeComparison.mode && (
                                            <Button
                                                type="button"
                                                size="small"
                                                text
                                                icon="pi pi-check"
                                                label="Choisir"
                                                onClick={() => {
                                                    setAdvancePaymentCollectionMode(bestAdvancePaymentFeeComparison.mode);
                                                    formik.setFieldValue('advancePaymentCollectionMode', bestAdvancePaymentFeeComparison.mode);
                                                }}
                                            />
                                        )}
                                    </div>
                                    <details>
                                        <summary>Voir le calcul des {advancePaymentFeeComparisons.length} service{advancePaymentFeeComparisons.length > 1 ? "s" : ""}</summary>
                                        <div className="rental-payment-fee-comparison__details">
                                            {advancePaymentFeeComparisons.map((comparison) => (
                                                <div key={comparison.name}>
                                                    <b>{comparison.name}</b>
                                                    <span>{comparison.percentage}% + {formatAmount(comparison.fixedFeeCents)} = {formatAmount(comparison.feesCents)} de frais</span>
                                                    <small>Vous conservez {formatAmount(comparison.netCents)} · mode {getAdvancePaymentModeLabel(comparison.mode)}</small>
                                                </div>
                                            ))}
                                        </div>
                                    </details>
                                </div>
                            )}
                            </div>

                        </>
                    )}

                    <div className="contentForm">
                        <div>Signature électronique nécessaire :&nbsp;</div >
                        <div className="flex flex-wrap gap-3">
                            <div className="flex align-items-center choiceDepositRadio">
                                <RadioButton inputId="signature-required-yes" name="signatureRequired" value="1" onChange={(e) => setSignatureRequired(e.value)} checked={signatureRequired === '1'} />
                                <label htmlFor="signature-required-yes" className="ml-2"> Oui</label>
                            </div>
                            <div className="flex align-items-center choiceDepositRadio">
                                <RadioButton inputId="signature-required-no" name="signatureRequired" value="0" onChange={(e) => setSignatureRequired(e.value)} checked={signatureRequired === '0'} />
                                <label htmlFor="signature-required-no" className="ml-2"> Non</label>
                            </div>

                        </div>
                    </div>




                    <div className="contentForm"></div >


                </Panel>


                <Panel className="rental-form-panel rental-form-panel-deposit" header={panelHeader("pi-shield", "Caution", "Choisissez le mode et le montant de caution.")}>

                    <div className="contentForm">
                        <div>Demander une caution :&nbsp;</div >
                        <div className="flex flex-wrap gap-3">
                            <div className="flex align-items-center choiceDepositRadio">
                                <RadioButton inputId="1" name="availableDeposit" value="1" onChange={(e) => setAvailableDeposit(e.value)} checked={availableDeposit === '1'} />
                                <label htmlFor="1" className="ml-2"> Oui</label>
                            </div>
                            <div className="flex align-items-center choiceDepositRadio">
                                <RadioButton inputId="0" name="availableDeposit" value="0" onChange={(e) => setAvailableDeposit(e.value)} checked={availableDeposit === '0'} />
                                <label htmlFor="0" className="ml-2"> Non</label>
                            </div>

                        </div>
                    </div>
                    {(availableDeposit === "1" ) && (
                        <>
                            <div className="rental-form-deposit-amount">
                                <span>Montant de la caution</span>
                                <b id="depositAmount">{(depositAmount) ? depositAmount + "€" : "Veuillez sélectionner un outil"}</b>
                            </div>
                            <div className="flex contentForm">
                                {radioBtns.map((btn, i) => {
                                    return (
                                        <div className="flex depositRadio" key={i} >
                                            <RadioButton
                                                {...btn}
                                                checked={formik.values.deposit === btn.value}
                                                onChange={(e) => {
                                                    formik.setFieldValue('deposit', e.value);
                                                    selectedDeposit(e.value);
                                                }}
                                            />
                                            <label htmlFor={btn.inputId} >
                                                {btn.trad}
                                            </label>

                                        </div>
                                    );
                                })}
                                {getFormErrorMessage('deposit')}
                            </div>
                            {(permanentLinkDepositBloc === true) && (
                                 <>
                                <div className="contentForm permanentLinkDepositBloc" >
                                    <p>La location fait plus de 3 jours et la caution n'est pas pris en charge par Lokapp passé ce délai. Veuillez saisir un lien d'un service externe (Swikly par exemple) !</p>
                                    <p>Ce lien sera envoyé au locataire pour qu'il puisse déposer la caution.</p>
                                    <div className="contentForm "></div >
                                   

                                </div >

                                <div className="contentForm">
                                 <span className="p-float-label">

                                        <InputText id="permanentLinkDeposit" name="permanentLinkDeposit" value={formik.values.permanentLinkDeposit} data-cy="permanentLinkDeposit"

                                            onChange={(e) => {
                                                formik.setFieldValue('permanentLinkDeposit', e.target.value);
                                            }}
                                            className={classNames({ 'p-invalid': isFormFieldInvalid('permanentLinkDeposit') })}
                                        />
                                        <label htmlFor="permanentLinkDeposit">Lien pour déposer la caution</label>
                                    </span>
                                    </div >
                                </>
                            )}
                            
                        </>
                    )}

                    
                   

                    <div className="contentForm"></div >
                    
                </Panel>

                <div className="rental-form-total-bar" aria-live="polite">
                    <div>
                        <span>Prix total de la location</span>
                        <small>{customRentalPriceAmount > 0 ? "Prix personnalisé appliqué" : "Matériel, options et frais inclus"}</small>
                    </div>
                    <b>{rentalTotalReady ? `${formatMoneyValue(rentalTotalAmount)}€` : "À calculer"}</b>
                </div>

                <div className="rental-form-actions">
                    <span>Vérifiez les informations avant d'enregistrer la location.</span>
                    <div>
                    <Button type="submit" data-cy="saveRentalBtn" icon="pi pi-save" loading={isSaving} disabled={isSaving}>Enregistrer</Button>
                    {(rental && rental.status === "Draft") ?
                        (<Button severity="secondary" type="button" onClick={deleteLocation} className="p-button-danger">Supprimer le brouillon</Button>)
                        :
                        (<Button severity="secondary" type="button" onClick={() => { navigate(-1); }}>Annuler</Button>)
                    }
                    {(localDraftId && !rental) ?
                        (<Button severity="secondary" type="button" onClick={deleteLocalDraft} className="p-button-danger">Supprimer le brouillon</Button>)
                        : null}
                    </div>
                </div>
            </Form>

            <div className="rental-form-calendar">
                <div className="rental-form-calendar-header">
                    <i className="pi pi-calendar-plus" aria-hidden="true"></i>
                    <div>
                        <h2>Disponibilités</h2>
                        <p>Consultez les évènements déjà planifiés pendant la saisie.</p>
                    </div>
                </div>
                <BookCalendar
                    events={appointments}
                    rentalEventDurationMinutes={settings?.rentalCalendarEventDurationMinutes}
                    rentalDeliveryEventDurationMinutes={settings?.rentalDeliveryCalendarEventDurationMinutes}
                    rentalDeliveryWithSetupEventDurationMinutes={settings?.rentalDeliveryWithSetupCalendarEventDurationMinutes}
                    rentalPickupEventDurationMinutes={settings?.rentalPickupCalendarEventDurationMinutes}
                />
            </div>

        </div>
    );

}
